(() => {
'use strict';

/* Shopify product 15394542584105: variant IDs read from the store on 8 Oct 2026 (checked again the same evening)
   and assigned to the masks by the store owner. Add to Cart sends exactly these variant IDs to Shopify, one cart
   item per picked design (the same design twice = quantity 2), with the mask name as the line label "Design".
   Original has no variant (sold out). */
const frostFaceProductId = '15394542584105';
const frostFaceVariants = {
  moustache: '67590010634537',   // NK308
  santa: '67590010700073',       // NKR313Thermal
  bald: '67590010667305',        // NKR310 Thermal
  grumpy: '67590010601769',      // NK307
};

/* =====================================================================
   STORE CONFIG — every fact the site shows comes from this block.
   Lines marked CONFIRM still need your real store data.
   ===================================================================== */
const CONFIG = {
  brand: 'OLD MAN MASK',
  tagline: 'One mask. Endless reactions.',
  supportEmail: '',                         // e.g. 'support@yourdomain.com' (shown on the contact page)

  promo: {
    label: 'WINTER SALE ENDS IN:',
    endsAt: null,                           // off: no countdown without a real sale end date, e.g. '2026-12-31T23:59:59+01:00'
    announcement: 'WINTER’S FUNNIEST MASK IS HERE ❄',
  },

  product: {
    title: 'Old Man Mask',
    titleLines: ['OLD MAN MASK', 'Realistic Winter Balaclava'],
    cartTitle: 'Old Man Mask',
    description: 'The realistic Old Man Mask: a funny winter balaclava in five old-man designs. One size, packed individually.',
    price: 34.99,                           // one mask
    compareAt: null,                        // only a real former price
    image: 'p1_bald_thumbsup',
  },
  // One Shopify variant per design (frostFaceVariants above). slide = gallery photo shown when the design is picked.
  // soldOut: the icon stays, with a small SOLD OUT badge, and the design can't be selected.
  designs: [
    // The five designs, in display order. img = the icon cut from the supplied reference image (used in every
    // mask row and in the cart).
    { id: 'original', name: 'Original', img: 'i_original', slide: 5, variantId: null, soldOut: true },   // no Shopify variant
    { id: 'moustache', name: 'Moustache', img: 'i_moustache', slide: 2, variantId: frostFaceVariants.moustache },
    { id: 'santa', name: 'Santa', img: 'i_santa', slide: 3, variantId: frostFaceVariants.santa },
    { id: 'bald', name: 'Bald', img: 'i_bald', slide: 0, variantId: frostFaceVariants.bald },
    { id: 'grumpy', name: 'Grumpy', img: 'i_grumpy', slide: 1, variantId: frostFaceVariants.grumpy },
  ],
  bundle: {
    name: 'REALISTIC OLD MAN BALACLAVA',
    summary: 'One mask in the design you pick',
    includes: [
      { name: 'Old Man Mask in your design', img: 'i_original', qty: '1×' },
    ],
  },
  freeShipping: true,                       // free shipping on every order
  trustline: 'Secure checkout · One size',
  trustBar: [['snow', 'WINTER READY']],    // shown after FREE SHIPPING, followed by the confirmed return period

  // Product details: facts from the pack and the product photos only.
  details: [
    ['Type', 'Balaclava-style face covering'],
    ['Covers', 'Head, face and neck'],
    ['Size', 'One size, as printed on the pack'],
    ['Eye window', 'Black-rimmed mesh'],
    ['Fabric', 'Thin and stretchy, listed as breathable on the pack'],
    ['Designs', 'Original, Moustache, Santa, Bald, Grumpy'],
    ['Packaging', 'One mask per pack'],
    ['Care', 'See the care label in your mask'],
  ],

  // Multi-buy prices (designs can be mixed). On Shopify, create matching automatic discounts
  // (2 masks → €49.99, 3 masks → €64.99) so the checkout total equals what the page shows.
  tiers: [
    { qty: 1, price: 34.99 },
    { qty: 2, price: 49.99, badge: 'MOST POPULAR' },   // keep this badge only while the 2-mask bundle really sells most
    { qty: 3, price: 64.99, badge: 'BEST VALUE' },     // lowest price per mask
  ],

  // 14-day right of withdrawal for orders within the EU (see the Refund Policy).
  guarantee: { days: 14, confirmed: true },
  // Money-back guarantee for damaged or defective products (guarantee section). Set confirmed: true once your
  // Refund Policy says the same; until then it appears in the preview only, never on the live store.
  moneyBack: { days: 90, confirmed: false },
  warranty: '',                             // optional warranty text for the FAQ
  deliveryTime: '',                         // CONFIRM, e.g. '5–8 business days'. Empty = shown at checkout

  // Reviews: real data only. Paste/import real reviews here or connect a review app.
  reviewSummary: { average: null, count: null, distribution: null }, // e.g. 4.3, 116, [5★, 4★, 3★, 2★, 1★ counts]
  // Real reviews only. photo = customer photo URL (shown large, cropped to 4:5), focus = position to keep in view, e.g. '50% 35%'.
  // On Shopify, reviews and photos come from the theme editor (window.NIVORA_REVIEWS, same format).
  // SECURITY: this storefront is read-only for reviews. Adding, editing, deleting reviews and uploading review photos
  // happens only in the Shopify admin (theme editor section or a review app), which Shopify authenticates server-side.
  // Never add review-management buttons, forms, upload fields or endpoints to this page — hiding them with CSS/JS is not protection.
  reviews: [],                              // { name, date: 'YYYY-MM-DD', rating: 1–5, title, text, photo, focus, verified }
  showPlaceholders: false,                  // sample reviews off (owner's request, 8 Oct 2026): no review area until real reviews exist
  // Preview layout only (sample numbers): never shown on Shopify or with showPlaceholders off. Live: real review data only.
  exampleSummary: { average: 4.6, count: 119, distribution: [88, 21, 6, 2, 2] },
  // "119+ Happy Customers" row → scrolls to the reviews. Live: real customer photos (customerPhotos) or photos from real
  // reviews, count = real review count. Preview only: these sample review photos.
  socialProof: { previewPhotos: [{ img: 'r17', focus: '58% 30%' }, { img: 'r18', focus: '50% 36%' }, { img: 'r16', focus: '68% 36%' }, { img: 'r15', focus: '26% 30%' }] },

  // REAL PEOPLE. REAL REACTIONS. — genuine photos from real customers, used with their permission.
  // verified: true only if every photo comes from a verified purchase (label ✓ VERIFIED CUSTOMERS), otherwise CUSTOMER PHOTOS.
  // No photos = the section stays hidden. images: [{ img: 'https://…/photo.jpg', alt: 'Customer wearing the Santa design' }]
  customerPhotos: {
    verified: false,                        // true = every photo below is a confirmed customer
    section: false,                         // these four appear only in the top "Happy Customers" row
    // Confirmed by the store owner (5 Oct 2026): all four are real customers who bought the Old Man Mask
    // and gave permission to show their photo. The small blue check marks them as confirmed customers (no text).
    images: [
      { img: 'cust_2', alt: 'Customer photo', verified: true },
      { img: 'cust_3', alt: 'Customer photo', verified: true },
      { img: 'cust_4', alt: 'Customer photo', verified: true },
      { img: 'cust_1', alt: 'Customer photo', verified: true },
    ],
    // REAL PEOPLE. REAL REACTIONS. photo section: removed on the owner's request (8 Oct 2026). To bring it back,
    // list confirmed customer photos here, e.g. { img: 'r17', focus: '50% 40%' } (photos only, no invented texts).
    gallery: [],
  },

  payments: ['Visa', 'Mastercard', 'PayPal', 'Apple Pay', 'Google Pay', 'Klarna'], // CONFIRM against your checkout

  // Customer accounts are optional. This page never stores passwords.
  //  ''               → preview: forms validate, then explain that accounts aren't connected
  //  'shopify'        → classic Shopify customer accounts (forms post to /account/login, /account, /account/recover)
  //  'shopify-hosted' → new Shopify customer accounts (sign-in hosted by Shopify)
  //  'endpoint'       → your own auth API (HTTPS, session cookie), see endpoints
  // On Shopify the mode defaults to 'shopify'. The theme can pass the signed-in customer
  // to this page as window.NIVORA_CUSTOMER (see normalizeCustomer) for My Account / My Orders.
  auth: { mode: '', endpoints: { login: '', register: '', recover: '', logout: '' } },

  contact: { endpoint: '' },                // e.g. a Formspree URL. On Shopify the native contact form is used.
  // Real tracking: base URL of the tracking service (same service as NIVORA: Shopify + DSers + 17TRACK).
  // On Shopify use the app proxy path, e.g. '/apps/oldmanmask'. Empty = not connected (preview).
  tracking: {
    apiBase: '',
    trackingUrl: 'https://t.17track.net/en#nums={number}', // public carrier page for a known tracking number
  },
};

/* ===================================================================== */
const IMG = window.__IMG || {};
const doc = document, root = doc.documentElement;
const $ = (s, r = doc) => r.querySelector(s);
const $$ = (s, r = doc) => Array.from(r.querySelectorAll(s));
const mqReduce = matchMedia('(prefers-reduced-motion: reduce)');
const mqDesktop = matchMedia('(min-width: 1024px)');
const smooth = () => (mqReduce.matches ? 'auto' : 'smooth');
const IS_SHOPIFY = !!(window.Shopify && window.Shopify.shop);
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const sleep = ms => new Promise(r => setTimeout(r, ms));
const imgSrc = k => IMG[k] || k || '';
const strip = html => { const d = doc.createElement('div'); d.innerHTML = html; return d.textContent.replace(/\s+/g, ' ').trim(); };

/* ---------- Shopify theme bridge ----------
   On the Shopify store, the theme (layout/theme.liquid) passes the real product as window.OMM_SHOP:
   each design gets the variant with the same name (Original, Moustache, …) and the price comes from Shopify.
   The preview has no window.OMM_SHOP, so nothing below runs there. */
const SHOP = window.OMM_SHOP || null;
const ROOT = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
const SETUP = [];   // shown only inside the Shopify theme editor: what still needs setting up
if (SHOP) {
  const s = SHOP.settings || {};
  if (typeof s.supportEmail === 'string' && s.supportEmail.trim()) CONFIG.supportEmail = s.supportEmail.trim();
  if (typeof s.deliveryTime === 'string' && s.deliveryTime.trim()) CONFIG.deliveryTime = s.deliveryTime.trim();
  const p = SHOP.product;
  if (!p) SETUP.push(`No product found. Choose product ${frostFaceProductId} in the “Store settings” section → Product.`);
  else {
    // the masks use their fixed variant IDs (frostFaceVariants); here they are only checked against the product
    if (String(p.id) !== frostFaceProductId) SETUP.push(`The page uses “${p.title}”, but the masks are linked to product ${frostFaceProductId}. Choose that product in the “Store settings” section → Product.`);
    const vs = Array.isArray(p.variants) ? p.variants : [], prices = [];
    CONFIG.designs.forEach(d => {
      if (!d.variantId) return;   // Original: no Shopify variant
      const v = vs.find(x => String(x.id) === String(d.variantId));
      if (!v) { SETUP.push(`Variant ${d.variantId} (${d.name}) is not part of “${p.title}”.`); return; }
      if (!d.soldOut) prices.push(Number(v.price));
    });
    if (prices.length) {
      CONFIG.product.price = Math.min(...prices) / 100;   // one mask = the Shopify price
      CONFIG.tiers.forEach(t => { if (t.qty === 1) t.price = CONFIG.product.price; });
      if (new Set(prices).size > 1) SETUP.push('Your design variants have different prices. The page shows the lowest one.');
    }
  }
  if (SHOP.currency && SHOP.currency !== 'EUR') SETUP.push(`Your store currency is ${SHOP.currency}. This page shows prices in euros.`);
  if (SHOP.designMode) doc.addEventListener('shopify:section:load', () => location.reload());
}
// Shopify pages that replace preview-only screens: the store's real policies
function shopifyHref(href) {
  if (!SHOP) return '';
  const path = decodeURIComponent(String(href || '').replace(/^#\/?/, '')).replace(/\/+$/, '').toLowerCase();
  const m = path.match(/^policies\/([a-z-]+)$/);
  if (m) return `${ROOT}policies/${m[1] === 'cookie-policy' ? 'privacy-policy' : m[1]}`;
  return '';
}
let contactPosted = false;
if (SHOP && /(?:^|[?&])contact_posted=true(?:&|$)/.test(location.search.slice(1))) {
  contactPosted = true;   // back from Shopify's contact form: show the confirmation on the contact page
  history.replaceState(null, '', `${location.pathname}#/contact`);
} else if (SHOP && doc.querySelector('#cfStatus .errors') && !/^#\/contact/.test(location.hash)) {
  history.replaceState(null, '', `${location.pathname}${location.search}#/contact`);   // Shopify's error message: show it on the form
}

/* prices are handled in cents to keep every total exact */
const PRICE = Math.round(CONFIG.product.price * 100);
const money = cents => {
  const neg = cents < 0, a = Math.abs(Math.round(cents));
  const int = String(Math.floor(a / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${neg ? '−' : ''}€${int},${String(a % 100).padStart(2, '0')}`;
};
const TIER_CENTS = CONFIG.tiers.map(t => ({ qty: t.qty, cents: Math.round(t.price * 100) }));
const discountFor = n => TIER_CENTS.reduce((best, t) => (t.qty <= n ? Math.max(best, t.qty * PRICE - t.cents) : best), 0);
const totalFor = qty => qty * PRICE - discountFor(qty);
const designById = id => CONFIG.designs.find(d => d.id === id) || CONFIG.designs[0];
const dFmt = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
const dtFmt = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
const fmtDate = (v, time) => { const d = new Date(v); return Number.isNaN(d.getTime()) ? String(v) : (time ? dtFmt : dFmt).format(d); };

const sv = (d, w = 1.8) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${w}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
const ICON = {
  truck: sv('<path d="M2.5 6.5h11v9.5h-11z"/><path d="M13.5 9.5h4l3 3.3v3.2h-7"/><circle cx="6.5" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/>'),
  check: sv('<path d="m5 12.5 4.5 4.5L19 7.5"/>', 2.2),
  plus: sv('<path d="M12 5v14M5 12h14"/>', 2),
  minus: sv('<path d="M5 12h14"/>', 2),
  box: sv('<path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/>'),
  route: sv('<path d="M4 12h13"/><path d="m13 6 6 6-6 6"/>', 2),
  pin: sv('<path d="M12 21s-6.5-6.2-6.5-11a6.5 6.5 0 0 1 13 0c0 4.8-6.5 11-6.5 11Z"/><circle cx="12" cy="10" r="2.4"/>'),
  home: sv('<path d="M4 11 12 4l8 7v9H4z"/><path d="m9 14.5 2 2 4-4"/>'),
  camera: sv('<path d="M4 8h3.2l1.6-2.2h6.4L16.8 8H20v11H4z"/><circle cx="12" cy="13.2" r="3.4"/>'),
  user: sv('<circle cx="12" cy="8.5" r="3.6"/><path d="M4.8 19.6c1.5-3.3 4.1-5 7.2-5s5.7 1.7 7.2 5"/>'),
  chevDown: sv('<path d="m6 9.5 6 6 6-6"/>', 2),
  chevRight: sv('<path d="m9.5 6 6 6-6 6"/>', 2),
  checkCircle: sv('<circle cx="12" cy="12" r="9"/><path d="m8 12.3 2.8 2.8L16.2 9.6"/>'),
  alert: sv('<circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.4v.1"/>', 2),
  bag: sv('<path d="M5.5 8.5h13l-1 11.5h-11l-1-11.5Z"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/>'),
  doc: sv('<path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4M9 12h6M9 16h6"/>'),
  q: sv('<circle cx="12" cy="12" r="9"/><path d="M9.6 9.4a2.5 2.5 0 1 1 3.4 2.3c-.6.3-1 .8-1 1.5v.4M12 16.6v.1"/>', 2),
  snow: sv('<path d="M12 2.5v19M3.8 7.25l16.4 9.5M3.8 16.75l16.4-9.5"/><path d="M9.4 4.3 12 6.9l2.6-2.6M9.4 19.7 12 17.1l2.6 2.6"/>'),
  battery: sv('<rect x="2" y="7" width="16" height="10" rx="2"/><path d="M22 11v2"/><path d="M6 11v2M10 11v2"/>'),
  returns: sv('<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>'),
  copy: sv('<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/>'),
  checkBold: sv('<path d="m5 12.5 4.5 4.5L19 7.5"/>', 3.4),
  eye: sv('<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z"/><circle cx="12" cy="12" r="3"/>'),
  eyeOff: sv('<path d="M3 3l18 18"/><path d="M10.6 5.6A9.8 9.8 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17 17 0 0 1-3.2 3.9M6.4 6.9C3.9 8.6 2.5 12 2.5 12S6 18.5 12 18.5c1.6 0 3-.4 4.2-1"/><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/>'),
  gear: sv('<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1Z"/>', 1.6),
  logout: sv('<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><path d="m16 17 5-5-5-5M21 12H9"/>'),
  verified: sv('<path d="m12 2.8 2.3 1.7 2.9-.1.9 2.7 2.3 1.7-.9 2.7.9 2.7-2.3 1.7-.9 2.7-2.9-.1L12 21.2l-2.3-1.7-2.9.1-.9-2.7-2.3-1.7.9-2.7-.9-2.7 2.3-1.7.9-2.7 2.9.1z"/><path d="m8.8 12.2 2.2 2.2 4.2-4.3"/>'),
};

/* ---------- policy templates (bracketed text to replace — no legal claims) ---------- */
const POLICIES = {
  'privacy-policy': { title: 'Privacy Policy', sections: [
    ['What we collect', '[Describe the personal information you collect, for example name, email, phone number, shipping address and order details. Card details are handled by your payment provider.]'],
    ['How we use it', '[Explain how you use it: processing orders, delivering shipments, customer support, and marketing only with consent.]'],
    ['Who we share it with', '[List the services that receive data, such as payment providers, shipping carriers and the apps that run the store.]'],
    ['Your rights', '[Explain how customers can access, correct or delete their data, and how to contact you about it.]'],
  ] },
  'refund-policy': { title: 'Refund Policy', sections: [
    ['Money-back guarantee', '[State your guarantee period and conditions, for example how many days after delivery a customer can ask for a refund.]'],
    ['How to start a return', '[Explain the steps: where to write, what to include, and where to send the item.]'],
    ['Refunds', '[Explain how and when refunds are issued and who pays for return shipping.]'],
    ['Damaged or faulty items', '[Explain what customers should do if an item arrives damaged or stops working.]'],
  ] },
  'shipping-policy': { title: 'Shipping Policy', sections: [
    ['Processing time', '[How long it takes to prepare an order before it ships.]'],
    ['Delivery times and costs', '[Delivery estimates by region, shipping costs and any free-shipping conditions.]'],
    ['Tracking', '[When the tracking number is sent, and how to use the Track Your Order page.]'],
    ['Customs and duties', '[If you ship internationally, explain who pays duties and taxes.]'],
  ] },
  'cookie-policy': { title: 'Cookie Policy', sections: [
    ['What cookies are', '[Explain that cookies are small files stored by the browser.]'],
    ['Cookies we use', '[List the essential cookies (cart, checkout, login) and any analytics or marketing cookies.]'],
    ['Your choices', '[Explain how visitors can accept, refuse or delete cookies, and link to your consent banner.]'],
  ] },
  'terms-of-service': { title: 'Terms of Service', sections: [
    ['Overview', '[Who operates the store and how these terms apply to purchases and use of the site.]'],
    ['Orders and pricing', '[How orders are accepted, how pricing errors are handled, and payment terms.]'],
    ['Product use', '[Intended-use notes for the mask, for example that the eye window limits your view and that it isn’t protective equipment.]'],
    ['Contact', '[Legal business name, address and contact email.]'],
  ] },
};

/* ---------- feature callouts on gallery slide 2 (positions in % of the product cut-out) ---------- */
const FEATURES = [];   // no callout slide: the gallery shows the 6 product photos only

// Editable PLACEHOLDER reviews for the preview layout only. They never appear on the Shopify store
// (and not when showPlaceholders is false). Each review has its own photo field; real reviews replace these.
const PH_REVIEWS = [
  { rating: 5, name: 'Tobias R.', photo: 'r17', focus: '50% 40%', title: 'Looks even better in person', text: 'I was honestly surprised by how realistic the mask looks up close. The details around the eyes and beard are crazy 😂' },
  { rating: 5, name: 'Emir H.', photo: 'r19', focus: '50% 30%', title: 'Perfect for random photos', text: 'Put it on before going out and took this elevator picture. My friends couldn’t stop laughing when they saw it.' },
  { rating: 5, name: 'Daniel M.', photo: 'r13', focus: '50% 42%', title: 'We had way too much fun with these', text: 'Bought two for me and my friend and they were an instant hit. Definitely made the evening more entertaining.' },
  { rating: 5, name: 'Jan P.', photo: 'r11', focus: '55% 50%', title: 'Gaming setup upgrade 😂', text: 'Ordered two because one wasn’t enough. They look hilarious sitting next to the gaming setup, and the masks are surprisingly detailed.' },
  { rating: 5, name: 'Luka B.', photo: 'r15', focus: '50% 30%', title: 'My friend loved it', text: 'Got this as a little surprise for my friend. He put it on immediately and we ended up taking pictures in the car 😂' },
  { rating: 5, name: 'Patrick S.', photo: 'r18', focus: '50% 40%', title: 'People actually stared', text: 'Wore it outside while working on the car and got some really funny reactions. The mask definitely gets attention!' },
  { rating: 5, name: 'Nikola K.', photo: 'r14', focus: '50% 40%', title: 'Best purchase for a laugh', text: 'My friend brought his too and we tried them on together. They look ridiculously realistic when you see two people wearing them.' },
  { rating: 5, name: 'Marco L.', photo: 'r08', focus: '50% 45%', title: 'Approved by the driveway', text: 'Put it on to clear the snow and kept it on all morning. The neighbours needed a second look.' },
  { rating: 5, name: 'Stefan W.', photo: 'r09', focus: '50% 78%', title: 'Unboxing was half the fun', text: 'Opened the box right there in the hallway and had it on before I even closed the door 😂' },
  { rating: 5, name: 'Alex D.', photo: 'r10', focus: '50% 30%', title: 'Mirror check: passed', text: 'Tried it on in front of the mirror and couldn’t stop laughing at my own reflection.' },
  { rating: 5, name: 'Florian G.', photo: 'r12', focus: '45% 40%', title: 'Instant party mood', text: 'Wore it at a friend’s place and everyone wanted a turn. Best laugh of the night.' },
  { rating: 5, name: 'Dominik R.', photo: 'r16', focus: '60% 40%', title: 'Elevator selfie, round two', text: 'Two of us, same mask, one elevator. Whoever was waiting on the next floor was not ready.' },
];

/* ===================================================================== */
const firstOpen = (CONFIG.designs.find(d => !d.soldOut) || CONFIG.designs[0]).id;   // sold-out designs are never preselected
const state = { qty: CONFIG.tiers[0].qty, designs: [0, 1, 2].map(() => firstOpen) };
// Shopify: store pages (policies, pages, 404, accounts) open on their own content, /pages/contact on the contact form
const START_VIEW = SHOP && (SHOP.view === 'page' || SHOP.view === 'contact') ? SHOP.view : 'home';
let currentView = START_VIEW;
const SEO_TITLE = doc.title;
const VIEWS = {};
$$('[data-view]').forEach(v => (VIEWS[v.dataset.view] = v));

const live = doc.createElement('div');
live.className = 'sr'; live.setAttribute('aria-live', 'polite');
doc.body.appendChild(live);
const announce = msg => { live.textContent = ''; setTimeout(() => (live.textContent = msg), 40); };

let toastTimer;
function toast(msg) {
  const t = $('#toast');
  t.textContent = msg; t.classList.add('is-shown');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove('is-shown'), 3400);
}
const alertBox = (type, title, text, actions = '') =>
  `<div class="alert alert--${type}" tabindex="-1">${type === 'ok' ? ICON.checkCircle : ICON.alert}<div><p class="alert__t">${title}</p>${text ? `<p class="alert__d">${text}</p>` : ''}${actions ? `<div class="alert__actions">${actions}</div>` : ''}</div></div>`;

function hydrate(scope = doc) {
  $$('img[data-img]', scope).forEach(el => {
    const s = IMG[el.dataset.img];
    if (s && el.getAttribute('src') !== s) { el.decoding = 'async'; el.src = s; }
  });
}

/* ---------- layers: menu, cart, search, lightbox ---------- */
const scrim = $('#scrim');
const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select, [tabindex]:not([tabindex="-1"])';
let layer = null, lastFocus = null;

function openLayer(el, opts = {}) {
  const { scrimOn = true, lock = true, focus } = opts;
  if (layer === el) return;
  if (layer) closeLayer(true);
  lastFocus = doc.activeElement;
  layer = el;
  el.inert = false; el.setAttribute('aria-hidden', 'false');
  el.classList.add('is-open');
  if (scrimOn) scrim.classList.add('is-on');
  if (lock) root.classList.add('is-locked');
  if (el.id === 'menu') $('#menuBtn').setAttribute('aria-expanded', 'true');
  const f = (focus && $(focus, el)) || $(FOCUSABLE, el);
  setTimeout(() => { if (f && layer === el) f.focus({ preventScroll: true }); }, 60);
  updateSticky();
}
function closeLayer(silent) {
  if (!layer) return;
  const el = layer; layer = null;
  el.classList.remove('is-open'); el.inert = true; el.setAttribute('aria-hidden', 'true');
  scrim.classList.remove('is-on'); root.classList.remove('is-locked');
  if (el.id === 'menu') $('#menuBtn').setAttribute('aria-expanded', 'false');
  if (el.id === 'lightbox') $('#lbFig').classList.remove('is-zoomed');
  if (!silent && lastFocus && doc.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  updateSticky();
}
doc.addEventListener('keydown', e => {
  if (!layer) return;
  if (e.key === 'Escape') { e.preventDefault(); closeLayer(); return; }
  if (e.key !== 'Tab') return;
  const f = $$(FOCUSABLE, layer).filter(x => !x.hidden && x.getClientRects().length);
  if (!f.length) return;
  const first = f[0], last = f[f.length - 1];
  if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
});
scrim.addEventListener('click', () => closeLayer());
doc.addEventListener('click', e => {
  if (e.target.closest('[data-close]')) { closeLayer(); return; }
  if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openLayer($('#cart'), { focus: '[data-close]' }); }
});

/* ---------- routing (hash based in the preview) ---------- */
function parseRoute() {
  if (START_VIEW !== 'home' && !(location.hash || '').startsWith('#/')) return { view: START_VIEW };
  const path = decodeURIComponent((location.hash || '').replace(/^#\/?/, '')).replace(/\/+$/, '').toLowerCase();
  if (!path) return { view: 'home' };
  if (path === 'shop') return { view: 'home', target: 'product' };
  if (path === 'faq') return { view: 'home', target: 'faq' };
  if (path === 'reviews') return { view: 'home', target: 'reviews' };
  if (path === 'contact') return { view: 'contact' };
  if (path === 'track') return { view: 'track' };
  if (/^account(\/|$)/.test(path)) return { view: 'home' };   // customer accounts are not offered in this store (removed 8 Oct 2026)
  const m = path.match(/^policies\/([a-z-]+)$/);
  if (m && POLICIES[m[1]]) return { view: 'policy', policy: m[1] };
  return { view: 'home' };
}
function scrollToId(id, smoothly) {
  const el = doc.getElementById(id);
  if (el) el.scrollIntoView({ behavior: smoothly ? smooth() : 'auto', block: 'start' });
}
function setNav(r) {
  const key = r.view === 'home' ? (r.target === 'faq' ? 'faq' : '') : r.view;
  $$('[data-nav]').forEach(a => (a.dataset.nav === key ? a.setAttribute('aria-current', 'page') : a.removeAttribute('aria-current')));
}
function setTitle(r) {
  const titles = { home: SEO_TITLE, contact: `Contact Us – ${CONFIG.brand}`, track: `Track Your Order – ${CONFIG.brand}`, account: `My Account – ${CONFIG.brand}` };
  doc.title = r.view === 'policy' ? `${POLICIES[r.policy].title} – ${CONFIG.brand}` : titles[r.view] || SEO_TITLE;
}
function applyRoute(opts = {}) {
  const first = !!opts.first;
  const r = parseRoute();
  const real = (r.view === 'policy' || r.view === 'account') && shopifyHref(location.hash);
  if (real) { location.replace(real); return; }   // Shopify: the store's own policy pages and customer accounts
  closeLayer(true);
  const from = VIEWS[currentView], to = VIEWS[r.view];
  if (r.view === 'policy') renderPolicy(r.policy);
  if (r.view === 'account') renderAccount(r);
  const finish = sameView => {
    setNav(r); setTitle(r);
    if (r.target) {
      if (first || !sameView) requestAnimationFrame(() => scrollToId(r.target, false));
      else scrollToId(r.target, true);
    }
    updateSticky();
  };
  if (from === to && r.view !== 'policy' && r.view !== 'account') {
    if (!r.target && !first) window.scrollTo({ top: 0, behavior: smooth() });
    finish(true);
    if (r.view === 'track') onTrackShown();
    return;
  }
  const swap = () => {
    from.hidden = true; from.classList.remove('is-leaving', 'is-entering');
    to.hidden = false; to.classList.remove('is-entering'); void to.offsetWidth; to.classList.add('is-entering');
    currentView = r.view;
    window.scrollTo(0, 0);
    if (!first && r.view !== 'home') { const h = $('h1', to); if (h) { h.tabIndex = -1; h.focus({ preventScroll: true }); } }
    window.dispatchEvent(new Event('resize'));
    finish(false);
    if (r.view === 'track') onTrackShown();
  };
  if (first || mqReduce.matches || from === to) swap();
  else { from.classList.add('is-leaving'); setTimeout(swap, 170); }
}
const nav = href => (location.hash === href ? applyRoute() : (location.hash = href));
function goSection(id) {
  if (currentView === 'home') scrollToId(id, true);
  else { location.hash = '#/'; setTimeout(() => scrollToId(id, false), 320); }
}
doc.addEventListener('click', e => {
  const a = e.target.closest('a[href^="#/"]');
  if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
  e.preventDefault();
  const real = shopifyHref(a.getAttribute('href'));
  if (real) { location.href = real; return; }
  nav(a.getAttribute('href'));
});
doc.addEventListener('click', e => {
  const b = e.target.closest('[data-scroll]');
  if (!b) return;
  e.preventDefault();
  goSection(b.dataset.scroll);
});
window.addEventListener('hashchange', () => { if (!location.hash || location.hash.startsWith('#/')) applyRoute(); });

/* ---------- promotion countdown (real, from CONFIG.promo.endsAt) ---------- */
function initCountdown() {
  const bar = $('#promo'), chip = $('#offerEnds');
  $('#promoLabel').textContent = CONFIG.promo.label;
  $('#announceTxt').textContent = CONFIG.promo.announcement;
  const end = Date.parse(CONFIG.promo.endsAt);
  if (!CONFIG.promo.endsAt || Number.isNaN(end)) { bar.hidden = true; if (chip) chip.hidden = true; return; }
  const el = $('#countdown');
  const unit = k => $(`[data-u="${k}"]`, el);
  const parts = { d: unit('d'), h: unit('h'), m: unit('m'), s: unit('s') };
  const dSep = $('[data-sep="d"]', el);
  const pad = v => String(v).padStart(2, '0');
  let timer;
  const set = (k, v) => {
    const b = parts[k].firstElementChild, t = pad(v);
    if (b.textContent === t) return;
    b.textContent = t;
    if (k === 's' && !mqReduce.matches) { b.classList.remove('tick'); void b.offsetWidth; b.classList.add('tick'); }
  };
  const tick = () => {
    const ms = end - Date.now();
    if (ms <= 0) { bar.hidden = true; if (chip) chip.hidden = true; return; }
    let s = Math.floor(ms / 1000);
    const d = Math.floor(s / 86400); s -= d * 86400;
    const h = Math.floor(s / 3600); s -= h * 3600;
    const m = Math.floor(s / 60); s -= m * 60;
    parts.d.hidden = dSep.hidden = d === 0;
    set('d', d); set('h', h); set('m', m); set('s', s);
    el.setAttribute('aria-label', `Sale ends in ${d ? `${d} days, ` : ''}${h} hours and ${m} minutes`);
    if (chip) { chip.hidden = false; chip.textContent = d ? `Ends in ${d}d ${pad(h)}h ${pad(m)}m` : `Ends in ${pad(h)}h ${pad(m)}m ${pad(s)}s`; }
    timer = setTimeout(tick, 1000 - (Date.now() % 1000) + 15);
  };
  tick();
  doc.addEventListener('visibilitychange', () => { if (!doc.hidden) { clearTimeout(timer); tick(); } });
}

/* ---------- header + simplified menu ---------- */
function initHeader() {
  const hdr = $('#hdr'), sentinel = $('#hdrSentinel');
  sentinel.style.cssText = 'height:1px;margin-bottom:-1px';
  new IntersectionObserver(([e]) => hdr.classList.toggle('is-stuck', !e.isIntersecting && e.boundingClientRect.top < 1)).observe(sentinel);
  $('#menuBtn').addEventListener('click', () => openLayer($('#menu'), { focus: '[data-close]' }));
  const MENU = [['Home', IS_SHOPIFY ? ROOT : '#/'], ['Contact Us', '#/contact'], ['FAQ', '#/faq'], ['Track Your Order', '#/track']];
  $('#menuList').innerHTML = MENU.map(([t, h], i) => `<li style="--i:${i}"><a href="${h}">${t}${ICON.chevRight}</a></li>`).join('');
}

/* ---------- search ---------- */
let INDEX = [];
const norm = s => String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9±° ]+/g, ' ');
function buildIndex() {
  const page = (t, k, href) => ({ t, k, type: 'Page', icon: ICON.doc, go: () => nav(href) });
  INDEX = [
    { t: CONFIG.product.title, k: 'old man mask balaclava face winter funny realistic costume prank gift price buy', type: `Mask, ${money(PRICE)}`, icon: ICON.snow, go: () => nav('#/shop') },
    ...CONFIG.designs.map((d, i) => ({ t: `${d.name} design`, k: `design designs face old man ${d.name.toLowerCase()} choose pick`, type: d.soldOut ? 'Design, sold out' : 'Design', icon: ICON.user, go: () => { if (!d.soldOut) { state.designs = state.designs.map(() => d.id); syncPicks(); } goSection('offer'); Gal.go(d.slide); } })),
    ...CONFIG.tiers.map(t => ({ t: `Buy ${t.qty}: ${t.qty} ${t.qty === 1 ? 'mask' : 'masks'}`, k: `bundle bundles quantity masks friends multi buy discount offer save ${money(totalFor(t.qty))}`, type: `Offer, ${money(totalFor(t.qty))}`, icon: ICON.box, go: () => { selectTier(t.qty); goSection('offer'); } })),
    ...FAQS().map((f, i) => ({ t: f.q, k: strip(f.a), type: 'FAQ', icon: ICON.q, go: () => goFaq(i) })),
    { t: 'Customer reviews', k: 'reviews ratings stars customers', type: 'Section', icon: ICON.chevRight, go: () => goSection('reviews') },
    { t: 'Product details', k: 'details specs size one size fabric breathable eye window mesh neck winter designs care', type: 'Product', icon: ICON.box, go: () => goSection('features') },
    page('FAQ', 'questions help answers', '#/faq'),
    page('Contact Us', 'contact email message support help question phone', '#/contact'),
    page('Track Your Order', 'track tracking shipping delivery order status package parcel where', '#/track'),
    page('Privacy Policy', 'privacy data personal information legal', '#/policies/privacy-policy'),
    page('Refund Policy', 'refund return returns money back guarantee exchange legal', '#/policies/refund-policy'),
    page('Shipping Policy', 'shipping delivery free shipping time cost customs legal', '#/policies/shipping-policy'),
    page('Terms of Service', 'terms conditions legal', '#/policies/terms-of-service'),
  ];
}
function searchIndex(q) {
  const toks = norm(q).split(/\s+/).filter(Boolean);
  if (!toks.length) return [];
  return INDEX.map(it => {
    const t = norm(it.t), hay = `${t} ${norm(it.k)}`;
    if (!toks.every(tok => hay.includes(tok))) return null;
    let score = 0;
    toks.forEach(tok => { score += t.startsWith(tok) ? 3 : t.includes(tok) ? 2 : 1; });
    return Object.assign({}, it, { score });
  }).filter(Boolean).sort((a, b) => b.score - a.score).slice(0, 8);
}
function markText(text, q) {
  const toks = q.trim().split(/\s+/).filter(Boolean).map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  if (!toks.length) return esc(text);
  const re = new RegExp(`(${toks.join('|')})`, 'ig');
  return text.split(re).map((part, i) => (i % 2 ? `<mark>${esc(part)}</mark>` : esc(part))).join('');
}
function initSearch() {
  const el = $('#search'), input = $('#sInput'), body = $('#sBody'), clear = $('#sClear');
  let results = [], active = -1;
  const open = () => {
    if (mqDesktop.matches) el.style.setProperty('--search-top', `${Math.max(8, $('#hdr').getBoundingClientRect().bottom + 8)}px`);
    openLayer(el, { scrimOn: false, lock: !mqDesktop.matches, focus: '#sInput' });
    render();
  };
  const go = r => { closeLayer(true); input.value = ''; r.go(); };
  const render = () => {
    const q = input.value.trim();
    clear.hidden = !q; active = -1;
    if (!q) {
      results = [];
      body.innerHTML = `<p class="search__label">Popular searches</p><div class="chips">${['Designs', 'Size', 'Shipping', 'Returns', 'Track order'].map(c => `<button class="chip" type="button" data-q="${c}">${c}</button>`).join('')}</div>`;
      return;
    }
    results = searchIndex(q);
    if (!results.length) { body.innerHTML = `<p class="search__empty">No results for “${esc(q)}”. Try “size”, “designs” or “shipping”.</p>`; return; }
    body.innerHTML = `<p class="search__label">${results.length} result${results.length > 1 ? 's' : ''}</p><ul class="sr-list">${results.map((r, i) =>
      `<li><button class="sr-item" type="button" data-i="${i}"><span class="sr-item__ico">${r.icon}</span><span><span class="sr-item__t">${markText(r.t, q)}</span><span class="sr-item__k">${esc(r.type)}</span></span></button></li>`).join('')}</ul>`;
  };
  const highlight = () => $$('.sr-item', body).forEach((b, i) => { b.classList.toggle('is-active', i === active); if (i === active) b.scrollIntoView({ block: 'nearest' }); });
  $$('[data-search-open]').forEach(b => b.addEventListener('click', open));
  input.addEventListener('input', render);
  clear.addEventListener('click', () => { input.value = ''; render(); input.focus(); });
  input.addEventListener('keydown', e => {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!results.length) return;
      e.preventDefault();
      active = (active + (e.key === 'ArrowDown' ? 1 : -1) + results.length) % results.length;
      highlight();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      const r = results[active >= 0 ? active : 0];
      if (r) go(r);
    }
  });
  body.addEventListener('click', e => {
    const chip = e.target.closest('[data-q]');
    if (chip) { input.value = chip.dataset.q; render(); input.focus(); return; }
    const b = e.target.closest('.sr-item');
    if (b) go(results[+b.dataset.i]);
  });
  doc.addEventListener('pointerdown', e => {
    if (layer === el && mqDesktop.matches && !el.contains(e.target) && !e.target.closest('[data-search-open]')) closeLayer(true);
  });
}

/* ---------- lightbox ---------- */
const Lightbox = (() => {
  const el = $('#lightbox'), fig = $('#lbFig'), img = $('#lbImg'), count = $('#lbCount');
  let list = [], i = 0, sx = 0, sy = 0, moved = false, down = false;
  const show = () => {
    const it = list[i];
    fig.classList.remove('is-zoomed');
    fig.classList.toggle('is-cut', !!it.cut);
    img.src = imgSrc(it.img); img.alt = it.alt || '';
    count.textContent = `${i + 1} / ${list.length}`;
    $('#lbPrev').hidden = $('#lbNext').hidden = list.length < 2;
  };
  const step = d => { i = (i + d + list.length) % list.length; show(); };
  const origin = e => {
    const r = fig.getBoundingClientRect();
    const x = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
    const y = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
    img.style.transformOrigin = `${x}% ${y}%`;
  };
  fig.addEventListener('pointerdown', e => { down = true; moved = false; sx = e.clientX; sy = e.clientY; });
  fig.addEventListener('pointermove', e => {
    if (down && (Math.abs(e.clientX - sx) > 8 || Math.abs(e.clientY - sy) > 8)) moved = true;
    if (fig.classList.contains('is-zoomed') && (down || e.pointerType === 'mouse')) origin(e);
  });
  fig.addEventListener('pointerup', e => {
    if (!down) return;
    down = false;
    const dx = e.clientX - sx, dy = e.clientY - sy;
    if (!fig.classList.contains('is-zoomed') && moved && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { step(dx < 0 ? 1 : -1); return; }
    if (!moved) { origin(e); fig.classList.toggle('is-zoomed'); }
  });
  fig.addEventListener('pointercancel', () => { down = false; });
  $('#lbPrev').addEventListener('click', () => step(-1));
  $('#lbNext').addEventListener('click', () => step(1));
  el.addEventListener('keydown', e => { if (e.key === 'ArrowRight') step(1); if (e.key === 'ArrowLeft') step(-1); });
  el.addEventListener('click', e => { if (e.target === el) closeLayer(); });
  return { open(l, start = 0) { list = l; i = start; show(); openLayer(el, { scrimOn: false, focus: '.lb__close' }); } };
})();

/* ---------- gallery: the 6 product photos ---------- */
const Gal = { go() {} };
function initGallery() {
  const track = $('#gTrack'), slides = $$('.g-slide', track), thumbsWrap = $('#gThumbs');
  const list = slides.map(s => {
    if (s.dataset.lbImg) return { img: s.dataset.lbImg, alt: s.dataset.lbAlt || '', cut: true, feat: true };
    const im = $('img', s);
    return { img: im.dataset.img, alt: im.alt, cut: s.classList.contains('g-slide--cut') };
  });
  $('#gTotal').textContent = slides.length;
  thumbsWrap.innerHTML = list.map((it, i) =>
    `<button class="thumb${it.cut ? ' thumb--cut' : ''}${it.feat ? ' thumb--feat' : ''}${i === 0 ? ' is-active' : ''}" type="button" aria-label="${it.feat ? `Show image ${i + 1} of ${list.length}: features` : `Show image ${i + 1} of ${list.length}`}"${i === 0 ? ' aria-current="true"' : ''}><img src="${imgSrc(it.img)}" alt="" width="72" height="72" decoding="async"></button>`).join('');
  const thumbs = $$('.thumb', thumbsWrap);
  let idx = 0, raf = 0;
  const go = i => { i = (i + slides.length) % slides.length; track.scrollTo({ left: i * track.clientWidth, behavior: smooth() }); };
  const sync = () => {
    raf = 0;
    const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    if (i === idx || i < 0 || i >= slides.length) return;
    idx = i;
    thumbs.forEach((t, j) => { t.classList.toggle('is-active', j === idx); if (j === idx) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    $('#gIdx').textContent = idx + 1;
  };
  track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(sync); }, { passive: true });
  $('#gPrev').addEventListener('click', () => go(idx - 1));
  $('#gNext').addEventListener('click', () => go(idx + 1));
  thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
  track.addEventListener('keydown', e => {
    if (e.target !== track) return;
    if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
  });
  $('#gZoom').addEventListener('click', () => Lightbox.open(list, idx));
  window.addEventListener('resize', () => { track.scrollLeft = idx * track.clientWidth; });
  Gal.go = go;
}
function initFeatures() {
  if (!$('#featFig')) return;
  const fig = $('#featFig'), svgEl = $('#featLines'), stage = $('#featStage');
  const Y = 0.981;
  svgEl.innerHTML = FEATURES.map((f, i) => {
    const a = `x1="${f.x}" y1="${(f.y * Y).toFixed(2)}" x2="${f.ax}" y2="${(f.ay * Y).toFixed(2)}" pathLength="1" style="--i:${i}"`;
    return `<line class="halo" ${a}/><line class="ln" ${a}/>`;
  }).join('');
  fig.insertAdjacentHTML('beforeend', FEATURES.map((f, i) =>
    `<button class="hot" type="button" style="--x:${f.x}%;--y:${f.y}%;--i:${i}" data-f="${i}" aria-label="${i + 1}: ${f.t}">${i + 1}</button>
     <span class="tag" style="--ax:${f.ax}%;--ay:${f.ay}%;--i:${i}" data-al="${f.al}" data-f="${i}" aria-hidden="true">${f.s}</span>`).join(''));
  const setActive = i => $$('[data-f]', stage).forEach(el => el.classList.toggle('is-active', +el.dataset.f === i));
  stage.addEventListener('click', e => { const b = e.target.closest('.hot'); if (b) setActive(+b.dataset.f); });
  stage.addEventListener('mouseover', e => { const b = e.target.closest('.hot'); if (b && matchMedia('(hover:hover)').matches) setActive(+b.dataset.f); });
  const sw = () => { if (fig.clientWidth) svgEl.style.setProperty('--sw', (1.4 * 100 / fig.clientWidth).toFixed(3)); };
  sw(); window.addEventListener('resize', sw);
  if (mqReduce.matches) { stage.classList.add('is-in'); return; }
  new IntersectionObserver(([e]) => { if (e.isIntersecting) stage.classList.add('is-in'); }, { root: $('#gTrack'), threshold: 0.55 }).observe(stage);
}

/* ---------- trusted by customers: exactly the 4 supplied customer photos ---------- */
function fitTrustText() {
  const el = $('#trustTitleTxt');
  if (!el || !el.clientWidth) return;
  el.style.fontSize = ''; el.style.whiteSpace = '';
  let size = parseFloat(getComputedStyle(el).fontSize);
  while (el.scrollWidth > el.clientWidth + 0.5 && size > 10.5) { size -= 0.25; el.style.fontSize = `${size}px`; }
  if (el.scrollWidth > el.clientWidth + 0.5) el.style.whiteSpace = 'normal'; // last resort on very narrow screens: wrap instead of clipping
}
// Return period is only claimed when confirmed (or in the preview while placeholders are on).
function returnDays() {
  const g = CONFIG.guarantee || {};
  return g.days && (g.confirmed || (CONFIG.showPlaceholders && !IS_SHOPIFY)) ? g.days : null;   // live store: confirmed only
}
function renderTrustBar() {
  const days = returnDays();
  const items = [
    CONFIG.freeShipping && ['truck', 'FREE SHIPPING'],
    ...(CONFIG.trustBar || []),
    days && ['returns', `${days}-DAY RETURNS`],
  ].filter(Boolean);
  $('#tbar').innerHTML = items.map(([icon, label]) => `<li>${ICON[icon] || ICON.check}<span>${esc(label)}</span></li>`).join('');
}
function initFeaturesRow() {
  const list = $('#featsList');
  if (!list) return;
  initDots(list, $('#featsDots'), 'Show feature');   // feature images are informational only: no click, zoom or lightbox
}
function renderTrust() {
  const row = $('#trustPics'), { sum, cards, example } = reviewModel();
  const cp = CONFIG.customerPhotos || {};
  // genuine customer photos: each carries its own verified flag (or the global one)
  const real = (cp.images || []).filter(x => x && x.img).map(x => Object.assign({}, x, { verified: x.verified === true || cp.verified === true }));
  // remaining places: photos from real reviews (verified only if the review is), or the sample photos in this preview
  const fill = example
    ? (CONFIG.socialProof.previewPhotos || []).map(x => Object.assign({}, x, { verified: false }))
    : cards.filter(r => !r.ph && reviewPhoto(r)).map(r => ({ img: reviewPhoto(r), focus: r.focus, verified: r.verified === true }));
  const pics = [...fill.slice(0, Math.max(0, 4 - real.length)), ...real].slice(-4);   // real customers sit on the right, fully visible
  const counted = !!(sum && sum.count), gallery = galleryShown();
  if (!pics.length || (!counted && !real.length)) { row.hidden = true; return; }
  row.hidden = false;
  if (counted) {
    const n = Number(sum.count).toLocaleString('en-US');
    $('#trustTitleTxt').textContent = `${n}+ Happy Customers`;
    row.setAttribute('aria-label', `${n}+ happy customers. Go to the customer reviews.`);
  } else if (gallery) {
    // no reviews yet: real customers, no number; the row leads to their photos
    $('#trustTitleTxt').textContent = 'Happy Customers';
    row.setAttribute('aria-label', 'Happy customers. See the customer photos.');
    row.setAttribute('href', '#customers'); row.dataset.scroll = 'customers';
  } else {
    // no reviews and no photo section: the confirmed customers only, no number and nothing to jump to
    $('#trustTitleTxt').textContent = 'Happy Customers';
    row.removeAttribute('href'); delete row.dataset.scroll; row.removeAttribute('aria-label');
  }
  window.addEventListener('resize', fitTrustText);
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(fitTrustText);
  requestAnimationFrame(fitTrustText);
  // a small blue check only on photos that are verified purchases
  $('#trustRow').innerHTML = pics.map(x =>
    `<span class="tav"><img src="${esc(imgSrc(x.img))}" alt="" width="36" height="36" decoding="async"${x.focus ? ` style="object-position:${esc(x.focus)}"` : ''}>${x.verified ? `<i class="tav__check" aria-hidden="true">${ICON.checkBold}</i>` : ''}</span>`).join('');
}

/* ---------- offer: one bundle + multi-buy ---------- */
function renderOffer() {
  $('#bundlePrice').textContent = money(PRICE);
  const cmp = $('#bundleCompare');
  if (CONFIG.product.compareAt && CONFIG.product.compareAt > CONFIG.product.price) { cmp.hidden = false; cmp.textContent = money(Math.round(CONFIG.product.compareAt * 100)); }
  $('#detailsList').innerHTML = CONFIG.details.map(([k, v], i, arr) =>
    `<div${arr.length % 2 && i === arr.length - 1 ? ' class="is-wide"' : ''}><dt>${esc(k)}</dt><dd>${esc(v)}</dd></div>`).join('');
  // BUY 1 / BUY 2 / BUY 3 — the design of every mask is chosen INSIDE the selected offer (no other design selector)
  const wrap = $('#tiers');
  wrap.innerHTML = CONFIG.tiers.map(t => {
    const total = totalFor(t.qty), sel = t.qty === state.qty, n = `${t.qty} ${t.qty === 1 ? 'MASK' : 'MASKS'}`;
    // saving vs. buying the same number of single masks at the one-mask price (BUY 2 29%, BUY 3 38%; BUY 1 none)
    const full = t.qty * PRICE, off = full > total ? Math.round((full - total) / full * 100) : 0;
    const rows = Array.from({ length: t.qty }, (_, s) => `<div class="mrow" role="radiogroup" aria-labelledby="q${t.qty}m${s}l">
        <p class="mrow__lbl" id="q${t.qty}m${s}l"><span>MASK ${s + 1}</span><b data-name></b></p>
        <div class="mrow__sw">${CONFIG.designs.map(d => `<label class="sw${d.soldOut ? ' is-soldout' : ''}"><input class="sr" type="radio" name="q${t.qty}m${s}" value="${esc(d.id)}" data-slot="${s}" aria-label="${esc(d.name)}${d.soldOut ? ', sold out' : ''}"${d.soldOut ? ' disabled' : ''}><span class="sw__img"><img src="${esc(imgSrc(d.img))}" alt="" width="48" height="48" decoding="async"><i class="sw__check" aria-hidden="true">${ICON.checkBold}</i>${d.soldOut ? '<span class="sw__sold" aria-hidden="true">SOLD OUT</span>' : ''}</span><span class="sw__name" aria-hidden="true">${esc(d.name)}</span></label>`).join('')}</div>
      </div>`).join('');
    return `<div class="bo tier${sel ? ' is-selected' : ''}" data-qty="${t.qty}">
      <label class="bo__head">
        <input class="sr" type="radio" name="tier" value="${t.qty}"${sel ? ' checked' : ''} aria-label="Buy ${t.qty}: ${n.toLowerCase()}, ${money(total)}${off ? `, ${off}% off` : ''}${t.badge ? `, ${esc(t.badge.toLowerCase())}` : ''}">
        <span class="bo__radio" aria-hidden="true"></span>
        <span class="bo__main" aria-hidden="true"><span class="bo__title">BUY ${t.qty}${t.badge ? `<span class="bo__badge">${esc(t.badge)}</span>` : ''}</span><span class="bo__each">${n}</span></span>
        ${off ? `<span class="bo__price has-off" aria-hidden="true"><span class="bo__amt">${money(total)}</span><span class="bo__badge bo__off">${off}% OFF</span></span>` : `<span class="bo__price" aria-hidden="true">${money(total)}</span>`}
        <svg class="bo__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9.5 6 6 6-6"/></svg>
      </label>
      <div class="bo__pick"${sel ? '' : ' hidden'}>${rows}</div>
    </div>`;
  }).join('');
  wrap.closest('.tiers').hidden = CONFIG.tiers.length < 2;
  syncPicks();
  wrap.addEventListener('change', e => {
    const el = e.target;
    if (el.name === 'tier') { selectTier(+el.value, true); return; }
    const s = Number(el.dataset.slot);
    if (!Number.isInteger(s)) return;
    state.designs[s] = el.value;
    syncPicks();
    const d = designById(el.value);
    if (Number.isInteger(d.slide)) Gal.go(d.slide);
  });
  // a tap anywhere on a closed offer opens it
  wrap.addEventListener('click', e => {
    const card = e.target.closest('.bo');
    if (!card || card.classList.contains('is-selected') || e.target.closest('.bo__head')) return;
    selectTier(+card.dataset.qty, true);
  });
}
// every mask row shows its current design (Mask 1 is shared by BUY 1, 2 and 3, and so on)
function syncPicks() {
  $$('#tiers .mrow').forEach(row => {
    const first = $('input', row), d = designById(state.designs[+first.dataset.slot]);
    $$('input', row).forEach(i => { i.checked = i.value === d.id; });
    $('[data-name]', row).textContent = d.name;
  });
}
// selecting BUY 1/2/3: blue border + its mask rows; the tapped card stays exactly where it was under the finger
function selectTier(qty, keepInView) {
  const tier = CONFIG.tiers.find(t => t.qty === qty) || CONFIG.tiers[0];
  const card = $(`#tiers .bo[data-qty="${tier.qty}"]`);
  const top0 = keepInView && card ? card.getBoundingClientRect().top : null;
  state.qty = tier.qty;
  $$('#tiers .tier').forEach(c => {
    const on = +c.dataset.qty === state.qty;
    c.classList.toggle('is-selected', on);
    $('input[name="tier"]', c).checked = on;
    const pick = $('.bo__pick', c);
    if (pick) pick.hidden = !on;
  });
  if (top0 !== null) { const dy = card.getBoundingClientRect().top - top0; if (Math.abs(dy) > 0.5) window.scrollBy(0, dy); }
  const label = `ADD TO CART — ${money(totalFor(state.qty))}`;
  ['#atcLabel', '#satcLabel'].forEach(id => { const el = $(id); if (el.textContent !== label) el.textContent = label; });
}

/* ---------- reviews (real data, or clearly labelled preview placeholders) ---------- */
function starSpan(r, ph) {
  return `<span class="stars" style="--r:${r || 5}" role="img" aria-label="${r || 5} out of 5 stars${ph ? ' (sample)' : ''}">★★★★★</span>`;
}
// Placeholders only in the preview: never on a live Shopify store, even if showPlaceholders is left on.
const placeholdersAllowed = () => CONFIG.showPlaceholders && !IS_SHOPIFY;
function reviewModel() {
  const source = Array.isArray(window.NIVORA_REVIEWS) ? window.NIVORA_REVIEWS : CONFIG.reviews;   // theme editor first
  const real = source.filter(r => r && r.text);
  const rs = CONFIG.reviewSummary || {};
  let sum = null, example = false;
  if (rs.average && rs.count) sum = { average: rs.average, count: rs.count, distribution: rs.distribution || null, verified: !!rs.verified };
  else if (real.length) {
    const dist = [5, 4, 3, 2, 1].map(s => real.filter(r => Math.round(r.rating || 5) === s).length);
    const total = real.reduce((a, r) => a + (r.rating || 5), 0);
    sum = { average: Math.round((total / real.length) * 10) / 10, count: real.length, distribution: dist, verified: real.every(r => r.verified) };
  }
  if (!sum && !real.length && placeholdersAllowed()) { sum = Object.assign({ verified: false }, CONFIG.exampleSummary); example = true; }
  const cards = real.length ? real : placeholdersAllowed() ? PH_REVIEWS.map(r => Object.assign({ ph: true }, r)) : [];
  return { sum, cards, example };
}
function initDots(track, dots, label) {
  let pos = [];
  const update = () => {
    const x = track.scrollLeft;
    let best = 0;
    pos.forEach((p, i) => { if (Math.abs(p - x) < Math.abs(pos[best] - x)) best = i; });
    $$('button', dots).forEach((b, i) => { b.classList.toggle('is-active', i === best); b.setAttribute('aria-current', String(i === best)); });
  };
  const measure = () => {
    if (!track.clientWidth) return;
    const max = track.scrollWidth - track.clientWidth, tr = track.getBoundingClientRect();
    pos = [];
    Array.from(track.children).forEach((c, i) => {
      const p = i === 0 ? 0 : Math.min(max, Math.round(c.getBoundingClientRect().left - tr.left + track.scrollLeft));
      if (!pos.length || p - pos[pos.length - 1] > 4) pos.push(p);
    });
    if (max <= 4) pos = [0];
    dots.hidden = pos.length < 2;
    dots.innerHTML = pos.map((_, i) => `<button type="button" aria-label="${label} ${i + 1}"></button>`).join('');
    update();
  };
  dots.addEventListener('click', e => {
    const b = e.target.closest('button');
    if (b) track.scrollTo({ left: pos[$$('button', dots).indexOf(b)], behavior: smooth() });
  });
  let raf = 0;
  track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; update(); }); }, { passive: true });
  window.addEventListener('resize', measure);
  measure();
}
const STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.7l2.46 5 5.52.8-4 3.89.95 5.5L10 14.3l-4.93 2.6.95-5.5-4-3.9 5.52-.8z"/></svg>';
function starIcons(r, size = 15) {
  const v = Math.max(0, Math.min(5, Number(r) || 0)), row = STAR.repeat(5);
  return `<span class="rv-stars" style="--s:${size}px" role="img" aria-label="${v} out of 5 stars"><span class="rv-stars__row">${row}</span><span class="rv-stars__row rv-stars__fill" style="width:${(v / 5 * 100).toFixed(1)}%">${row}</span></span>`;
}
const VCHECK = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="m4.7 8.3 2.1 2.1 4.5-4.6" fill="none" stroke="#000" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
// each review uses its own photo (CONFIG.reviews / Shopify theme editor)
const reviewPhoto = r => r.photo || null;

let revCards = [];
function renderReviews() {
  const { sum, cards, example } = reviewModel();
  revCards = cards;
  const row = $('#ratingRow');
  if (!sum && !cards.length) { $('#reviews').hidden = true; row.hidden = true; return; }
  const n = v => Number(v).toLocaleString('en-US');
  if (sum) {
    row.hidden = false;
    $('#ratingStars').style.setProperty('--r', sum.average);
    $('#ratingNum').textContent = `${sum.average.toFixed(1)} / 5`;
    $('#ratingTxt').textContent = `· ${n(sum.count)} Review${sum.count === 1 ? '' : 's'}`;
    row.setAttribute('aria-label', `${sum.average.toFixed(1)} out of 5 from ${n(sum.count)} reviews. Go to reviews.`);
  } else row.hidden = true;

  // summary: average, stars, basis, distribution (real data, or the preview example)
  const box = $('#revSum');
  if (sum) {
    const dist = Array.isArray(sum.distribution) && sum.distribution.length === 5 ? sum.distribution : null;
    box.innerHTML = `<div class="rv-sum__head">
        <p class="rv-sum__score"><span class="rv-sum__avg">${sum.average.toFixed(1)}</span><span class="rv-sum__of">/ 5</span></p>
        ${starIcons(sum.average, 19)}
        <p class="rv-sum__basis">Based on ${n(sum.count)} ${sum.verified ? 'verified ' : ''}review${sum.count === 1 ? '' : 's'}</p>
      </div>
      ${dist ? `<ul class="rv-dist" aria-label="Rating distribution">${dist.map((c, i) => `<li style="--i:${i}"><span class="rv-dist__k">${5 - i}★</span><span class="rv-dist__bar"><i style="--w:${(c / Math.max(1, sum.count) * 100).toFixed(1)}%"></i></span><span class="rv-dist__n">${n(c)}</span></li>`).join('')}</ul>` : ''}`;
  } else box.innerHTML = '<p class="rv-sum__basis">No reviews yet.</p>';
  renderReviewCards();
  initReviewGrid();
}
// review grid: [photo] · name + Verified · five stars · text (name, date and Verified only from the data)
function renderReviewCards() {
  const grid = $('#revTrack');
  grid.innerHTML = revCards.map((r, i) => {
    const src = reviewPhoto(r), focus = r.focus;
    return `<article class="rg-card">
      ${src ? `<div class="rg-card__media"><img src="${esc(imgSrc(src))}" alt="Photo from ${esc(r.name || 'a customer')}" width="720" height="900" loading="lazy" decoding="async"${focus ? ` style="object-position:${esc(focus)}"` : ''}></div>` : ''}
      <div class="rg-card__body">
        ${r.name || r.verified ? `<div class="rg-card__who">${r.name ? `<p class="rg-card__name">${esc(r.name)}</p>` : ''}${r.verified ? `<span class="rg-card__ver" role="img" aria-label="Verified purchase">${VCHECK}</span>` : ''}</div>` : ''}
        ${starIcons(r.rating || 5, 13)}
        ${r.title ? `<p class="rg-card__t">${esc(r.title)}</p>` : ''}
        <p class="rg-card__txt">${esc(r.text)}</p><button class="rg-card__more" type="button" hidden>Read more</button>
        ${r.date ? `<p class="rg-card__date"><time datetime="${esc(r.date)}">${fmtDate(r.date)}</time></p>` : ''}
      </div>
    </article>`;
  }).join('');
  const sec = $('#reviews');
  sec.classList.toggle('has-more-m', revCards.length > 4);   // phones: first 4, then "show all"
  sec.classList.toggle('has-more-d', revCards.length > 8);   // larger screens: first 8
  $('#revMore').textContent = 'SHOW MORE REVIEWS';
  requestAnimationFrame(checkReviewClamp);
}
// "Read more" only on cards whose text is cut off
function checkReviewClamp() {
  $$('#revTrack .rg-card').forEach(card => {
    const t = $('.rg-card__txt', card), b = $('.rg-card__more', card);
    if (!t || !b || t.classList.contains('is-open') || !t.clientHeight) return;
    b.hidden = t.scrollHeight <= t.clientHeight + 1;
  });
}
let revGridReady = false;
function initReviewGrid() {
  if (!revCards.length || revGridReady) return;
  revGridReady = true;
  const sec = $('#reviews'), grid = $('#revTrack');
  $('#revMore').addEventListener('click', () => {
    const next = [...grid.children].find(c => getComputedStyle(c).display === 'none');
    sec.classList.add('is-expanded');
    checkReviewClamp();
    const f = next && $('button', next);
    if (f) f.focus({ preventScroll: true });
  });
  window.addEventListener('resize', () => requestAnimationFrame(checkReviewClamp));
  grid.addEventListener('click', e => {
    const more = e.target.closest('.rg-card__more');
    if (more) { const t = more.previousElementSibling; t.classList.add('is-open'); more.hidden = true; }   // review photos are display-only
  });
}
// REAL PEOPLE. REAL REACTIONS.: the confirmed customer photos (customerPhotos.gallery) on the live store.
// The preview shows its sample reviews instead. Photos only, display-only; the label never claims more than is true.
const galleryList = () => (((CONFIG.customerPhotos || {}).gallery) || []).filter(x => x && x.img);
const galleryShown = () => galleryList().length >= 2 && !reviewModel().example;
function renderCustomerPhotos() {
  const cp = CONFIG.customerPhotos || {}, list = galleryList();
  const sec = $('#customers');
  sec.hidden = !galleryShown();
  if (sec.hidden) return;
  const allVerified = cp.verified === true || list.every(x => x.verified === true);
  $('#custLabel').innerHTML = allVerified ? `${ICON.checkBold}<span>VERIFIED CUSTOMERS</span>` : '<span>CUSTOMER PHOTOS</span>';
  $('#custGrid').innerHTML = list.map(x => `<figure class="cust__item"><img src="${esc(imgSrc(x.img))}" alt="${esc(x.alt || 'Customer photo')}" width="720" height="900" loading="lazy" decoding="async"${x.focus ? ` style="object-position:${esc(x.focus)}"` : ''}></figure>`).join('');
  sec.classList.toggle('has-more-m', list.length > 4);   // phones: first 4, then SHOW MORE PHOTOS
  sec.classList.toggle('has-more-d', list.length > 8);   // larger screens: first 8
  $('#custMore').addEventListener('click', () => sec.classList.add('is-expanded'));
}
// money-back guarantee: only with a confirmed guarantee period (preview: the configured value)
function moneyBackDays() {
  const m = CONFIG.moneyBack || {};
  return m.days && m.confirmed ? m.days : null;
}
function renderGuarantee() {
  const sec = $('#guarantee'), days = moneyBackDays();
  sec.hidden = !days;
  if (!days) return;
  $('#gteeTitle').textContent = `${days}-Day Money-Back Guarantee`;
  $('#gteeTxt').textContent = `Every order is covered — if your product arrive damaged or defective, send a photo within ${days} days of delivery and it's made right: replacement or full refund, no arguments.`;
}

/* ---------- FAQ ---------- */
function FAQS() {
  const days = returnDays();
  const multi = CONFIG.tiers.filter(t => t.qty > 1);
  const ship = CONFIG.freeShipping ? 'Shipping is free. ' : '';
  return [
    { q: 'Is the mask one size?', a: '<p>Yes. Every Old Man Mask is one size, as printed on the pack.</p>' },
    { q: 'Can I see through the mask?', a: '<p>Yes. Your eyes sit behind a black-rimmed mesh window, so you can see out while the old-man face does the talking.</p><p>The mesh limits your view a little, so don’t wear the mask while driving, cycling, skiing or doing anything else where you need a clear view.</p>' },
    { q: 'Is it suitable for winter?', a: '<p>It’s a balaclava-style face covering for your head, face and neck, made for cold days outside: winter walks, ski huts, Christmas markets.</p><p>It isn’t protective equipment, so still wear a helmet or proper gear wherever you need it.</p>' },
    { q: 'Is the mask breathable?', a: '<p>The pack lists the mask as breathable. It’s a thin, stretchy fabric that covers your nose and mouth, so take it off whenever you feel uncomfortable.</p>' },
    { q: 'Which designs are there?', a: `<p>${['One', 'Two', 'Three', 'Four', 'Five', 'Six'][CONFIG.designs.length - 1] || CONFIG.designs.length} old men: ${CONFIG.designs.map(d => esc(d.name)).join(', ')}. Choose BUY 1, BUY 2 or BUY 3 and pick the design for each mask right inside the offer, so you can mix them as you like.</p>` },
    { q: 'How many masks are included?', a: '<p>One mask per pack. The 2-mask and 3-mask bundles contain 2 or 3 individually packed masks in the designs you choose.</p>' },
    ...(multi.length ? [{ q: 'Is there a discount for buying more than one?', a: `<p>Yes. ${multi.map(t => `${t.qty} masks cost ${money(totalFor(t.qty))} instead of ${money(t.qty * PRICE)}`).join(', and ')}. Choose the quantity just above the Add to Cart button.</p>` }] : []),
    { q: 'How do I clean it?', a: '<p>Follow the care label in your mask. If in doubt, hand-wash it in cold water with a mild detergent and let it air-dry.</p>' },
    { q: 'Can I wear it with glasses?', a: '<p>That depends on your frames. You can try wearing your glasses over the mask. Not sure? <a href="#/contact">Message us</a> before ordering and we’ll help.</p>' },
    { q: 'How long does shipping take?', a: CONFIG.deliveryTime
      ? `<p>${ship}Orders usually arrive within ${esc(CONFIG.deliveryTime)}. As soon as your order ships, you get a shipping confirmation and can follow it on <a href="#/track">Track Your Order</a>.</p>`
      : `<p>${CONFIG.freeShipping ? 'Shipping is free. The expected delivery time is shown at checkout before you pay.' : 'Shipping costs and the expected delivery time are shown at checkout before you pay.'} As soon as your order ships, you get a shipping confirmation and can follow it on <a href="#/track">Track Your Order</a>.</p>` },
    { q: 'How can I track my order?', a: '<p>Use <a href="#/track">Track Your Order</a> with your order number and email address. Once your order has shipped, you’ll see the current carrier status and the full tracking history.</p>' },
    { q: 'What is the return policy?', a: days
      ? `<p>For orders within the EU you have a ${days}-day right of withdrawal from the day you receive your order. You’ll find all details in our <a href="#/policies/refund-policy">Refund Policy</a>.</p>`
      : '<p>Our <a href="#/policies/refund-policy">Refund Policy</a> explains how returns work. If something isn’t right with your order, <a href="#/contact">contact us</a> and we’ll help.</p>' },
    { q: 'Do I need an account to order?', a: '<p>No. You can check out as a guest and follow your order on the <a href="#/track">Track Your Order</a> page with your order number and email address.</p>' },
    { q: 'What if my mask arrives damaged?', a: CONFIG.warranty ? `<p>${esc(CONFIG.warranty)}</p>` : '<p>If anything is wrong with your order, <a href="#/contact">contact us</a> with a photo and we’ll help. See the <a href="#/policies/refund-policy">Refund Policy</a> for the full terms.</p>' },
  ];
}
function accItem({ id, icon, title, body }) {
  return `<div class="acc__item" data-id="${id}">
    <h3 class="acc__h"><button class="acc__btn" type="button" id="${id}-b" aria-expanded="false" aria-controls="${id}-p"><span class="acc__ico">${icon}</span><span class="acc__title">${title}</span>${ICON.chevDown.replace('<svg', '<svg class="acc__chev"')}</button></h3>
    <div class="acc__panel" id="${id}-p" role="region" aria-labelledby="${id}-b"><div class="acc__inner"><div class="acc__body">${body}</div></div></div>
  </div>`;
}
doc.addEventListener('click', e => {
  const b = e.target.closest('.acc__btn');
  if (!b) return;
  const item = b.closest('.acc__item'), on = !item.classList.contains('is-open');
  item.classList.toggle('is-open', on);
  b.setAttribute('aria-expanded', String(on));
});
function renderFaq() {
  const list = FAQS();
  $('#faqList').innerHTML = list.map((f, i) => accItem({ id: `fq${i}`, icon: ICON.check, title: esc(f.q), body: f.a })).join('');
  $('#ldFaq').textContent = JSON.stringify({
    '@context': 'https://schema.org', '@type': 'FAQPage',
    mainEntity: list.map(f => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: strip(f.a) } })),
  });
}
function goFaq(i) {
  const run = () => {
    const item = $(`#faqList .acc__item[data-id="fq${i}"]`);
    if (!item) return;
    item.classList.add('is-open');
    $('.acc__btn', item).setAttribute('aria-expanded', 'true');
    item.scrollIntoView({ behavior: smooth(), block: 'center' });
  };
  if (currentView === 'home') run(); else { location.hash = '#/'; setTimeout(run, 340); }
}

/* ---------- cart: local in the preview, Shopify AJAX cart when live ---------- */
async function api(url, body) {
  const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  if (!r.ok) {
    let m = 'Something went wrong. Please try again.';
    try { m = (await r.json()).description || m; } catch (e) { /* keep default */ }
    throw new Error(m);
  }
  return r.json();
}
const Cart = {
  items: {},                               // { designId: quantity }
  sh: null,
  KEY: 'omm-cart-v1',
  get qty() { return Object.values(this.items).reduce((n, q) => n + q, 0); },
  load() {
    if (IS_SHOPIFY) { this.sync(); return; }
    try {
      const raw = JSON.parse(localStorage.getItem(this.KEY) || '{}'), items = {};
      CONFIG.designs.forEach(d => { const q = parseInt(raw.items && raw.items[d.id], 10); if (Number.isFinite(q) && q > 0) items[d.id] = Math.min(99, q); });
      this.items = items;
    } catch (e) { this.items = {}; }
    this.render();
  },
  save() { if (IS_SHOPIFY) return; try { localStorage.setItem(this.KEY, JSON.stringify({ items: this.items })); } catch (e) { /* storage unavailable */ } },
  totals() {
    const qty = this.qty;
    if (IS_SHOPIFY && this.sh) return { qty, subtotal: this.sh.original_total_price, discount: this.sh.total_discount, total: this.sh.total_price };
    const subtotal = qty * PRICE, total = totalFor(qty);
    return { qty, subtotal, discount: subtotal - total, total };
  },
  variant(id) {
    const d = designById(id);
    if (d.soldOut) throw new Error(`Sorry, the ${d.name} design is sold out.`);
    if (!d.variantId) throw new Error(`Sorry, the ${d.name} design isn’t available right now.`);
    return Number(d.variantId);   // the exact Shopify variant ID
  },
  async add(counts) {
    const entries = Object.entries(counts).filter(([, q]) => q > 0);
    if (IS_SHOPIFY) {
      // every picked mask goes to Shopify as its own variant ID (the item id); the mask name is only a visible
      // label on the line ("Design: Santa" in the cart, checkout and order)
      await api(`${ROOT}cart/add.js`, { items: entries.map(([id, q]) => ({ id: this.variant(id), quantity: q, properties: { Design: designById(id).name } })) });
      await this.sync();
    } else {
      entries.forEach(([id, q]) => { this.items[id] = Math.min(99, (this.items[id] || 0) + q); });
      this.save(); this.render();
    }
    $$('[data-cart-count]').forEach(b => { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); });
  },
  async setQty(id, qty) {
    qty = Math.max(0, Math.min(99, qty));
    if (IS_SHOPIFY) {
      // all cart lines of this mask's variant (a cart from before the Design label can hold two); the new
      // quantity goes to one line, preferably the labelled one, the others are emptied
      const d = designById(id);
      const lines = this.sh ? this.sh.items.filter(l => String(l.variant_id) === String(d.variantId)) : [];
      const keep = lines.find(l => l.properties && l.properties.Design === d.name) || lines[0];
      try {
        for (const l of lines) if (l !== keep) await api(`${ROOT}cart/change.js`, { id: l.key, quantity: 0 });
        if (keep) await api(`${ROOT}cart/change.js`, { id: keep.key, quantity: qty });
      } finally { await this.sync(); }   // the drawer always shows what Shopify really has
      return;
    }
    if (qty) this.items[id] = qty; else delete this.items[id];
    this.save(); this.render();
  },
  async sync() {
    try {
      this.sh = await (await fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' } })).json();
      const items = {};
      CONFIG.designs.forEach(d => { const q = d.variantId ? this.sh.items.filter(l => String(l.variant_id) === String(d.variantId)).reduce((n, l) => n + l.quantity, 0) : 0; if (q) items[d.id] = q; });
      this.items = items;
    } catch (e) { /* keep current */ }
    this.render();
  },
  render() {
    const t = this.totals(), n = t.qty;
    $$('[data-cart-count]').forEach(b => { b.textContent = n; b.classList.toggle('is-on', n > 0); });
    $('#cartBtn').setAttribute('aria-label', n ? `Open cart, ${n} mask${n > 1 ? 's' : ''}` : 'Open cart');
    const body = $('#cartBody'), foot = $('#cartFoot');
    if (!n) {
      body.innerHTML = `<div class="cart__empty">${ICON.bag}<p>Your cart is empty</p><a class="btn" href="#/shop">SHOP NOW</a></div>`;
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = CONFIG.designs.filter(d => this.items[d.id]).map(d => {
      const q = this.items[d.id];
      return `<div class="line" data-line="${esc(d.id)}">
      <div class="line__img"><img src="${esc(imgSrc(d.img))}" alt="" width="76" height="76"></div>
      <div class="line__info">
        <p class="line__t">${esc(CONFIG.product.cartTitle)}</p>
        <p class="line__v">Design: ${esc(d.name)}</p>
        <p class="line__unit">${money(PRICE)} per mask</p>
        <div class="line__bottom">
          <div class="qty" role="group" aria-label="Quantity, ${esc(d.name)}"><button type="button" data-qty="-1" data-design="${esc(d.id)}" aria-label="Decrease quantity, ${esc(d.name)}">${ICON.minus}</button><output aria-live="polite">${q}</output><button type="button" data-qty="1" data-design="${esc(d.id)}" aria-label="Increase quantity, ${esc(d.name)}">${ICON.plus}</button></div>
          <div class="line__prices"><span class="line__price">${money(q * PRICE)}</span></div>
        </div>
        <button class="line__rm" type="button" data-remove data-design="${esc(d.id)}">Remove</button>
      </div>
    </div>`;
    }).join('');
    const rows = [['Quantity', `${n} mask${n > 1 ? 's' : ''}`, ''], ['Price', money(t.subtotal), '']];
    if (t.discount > 0) rows.push(['Multi-buy discount', money(-t.discount), 'is-save']);
    rows.push(['Shipping', CONFIG.freeShipping ? 'FREE' : 'Calculated at checkout', CONFIG.freeShipping ? 'is-free' : '']);
    rows.push(['Total', money(t.total), 'is-total']);
    $('#cartSum').innerHTML = rows.map(([k, v, cls]) => `<div class="${cls}"><dt>${k}</dt><dd>${v}</dd></div>`).join('');
    const next = CONFIG.tiers.filter(x => x.qty > n).sort((a, b) => a.qty - b.qty)[0];
    const hint = $('#cartHint');
    hint.hidden = !next;
    if (next) { const diff = next.qty - n; hint.textContent = `Add ${diff} more mask${diff > 1 ? 's' : ''}: ${next.qty} masks for ${money(totalFor(next.qty))}.`; }
  },
};
function initCart() {
  $('#cartBody').addEventListener('click', async e => {
    const q = e.target.closest('[data-qty]'), rm = e.target.closest('[data-remove]');
    if (!q && !rm) return;
    const id = (q || rm).dataset.design;
    try { await Cart.setQty(id, rm ? 0 : (Cart.items[id] || 0) + Number(q.dataset.qty)); } catch (err) { toast(err.message); }
    const again = q && $(`#cartBody [data-design="${id}"][data-qty="${q.dataset.qty}"]`);
    if (again) again.focus(); else $('#cart [data-close]').focus();
    announce(Cart.qty ? `Cart updated: ${Cart.qty} mask${Cart.qty > 1 ? 's' : ''}, total ${money(Cart.totals().total)}.` : 'Cart is empty.');
  });
  $('#checkoutBtn').addEventListener('click', () => {
    if (IS_SHOPIFY) location.href = `${ROOT}checkout`;
    else toast('Checkout is currently unavailable. Please try again later.');
  });
  const add = async btn => {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    const t0 = performance.now(), qty = state.qty, counts = {};
    state.designs.slice(0, qty).forEach(id => { const k = designById(id).id; counts[k] = (counts[k] || 0) + 1; });
    try {
      await Cart.add(counts);
      const wait = 300 - (performance.now() - t0);
      if (wait > 0) await sleep(wait);
      btn.classList.remove('is-loading'); btn.classList.add('is-done');
      announce(`${qty} mask${qty > 1 ? 's' : ''} added to cart.`);
      await sleep(700);
      btn.classList.remove('is-done');
      openLayer($('#cart'), { focus: '[data-close]' });
    } catch (err) {
      btn.classList.remove('is-loading');
      toast(err.message || 'Could not add to cart. Please try again.');
    } finally { btn.removeAttribute('aria-busy'); }
  };
  $('#atc').addEventListener('click', e => add(e.currentTarget));
  $('#satcBtn').addEventListener('click', e => add(e.currentTarget));
  Cart.load();
}

/* ---------- sticky add-to-cart, back to top ---------- */
let atcPassed = false, endInView = false;
function updateSticky() {
  const satc = $('#satc');
  const show = currentView === 'home' && atcPassed && !endInView && !layer && !mqDesktop.matches;
  satc.classList.toggle('is-shown', show);
  satc.inert = !show; satc.setAttribute('aria-hidden', String(!show));
  doc.body.classList.toggle('has-satc', show);
}
function initScrollUi() {
  const atcEl = $('#atc'), toTop = $('#toTop');
  new IntersectionObserver(([e]) => { endInView = e.isIntersecting; updateSticky(); }).observe($('#footer'));
  mqDesktop.addEventListener('change', updateSticky);
  toTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: smooth() }));
  let ticking = false;
  const onScroll = () => {
    ticking = false;
    const passed = currentView === 'home' && atcEl.getBoundingClientRect().bottom < 0;
    if (passed !== atcPassed) { atcPassed = passed; updateSticky(); }
    toTop.classList.toggle('is-on', window.scrollY > 700);
  };
  window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  window.addEventListener('resize', () => { updateSticky(); onScroll(); });
  onScroll();
}

/* ---------- reveal (subtle, used sparingly) ---------- */
let revealIO = null;
function observeInView(el) { if (revealIO) revealIO.observe(el); else el.classList.add('is-in'); }
function initReveal() {
  if (mqReduce.matches) { $$('[data-reveal], [data-inview]').forEach(el => el.classList.add('is-in')); return; }
  revealIO = new IntersectionObserver(es => es.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('is-in');
    revealIO.unobserve(e.target);
  }), { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
  $$('[data-reveal], [data-inview]').forEach(el => revealIO.observe(el));
}

/* ---------- snow particles (FAQ background, paused off-screen) ---------- */
function initSnow() {
  const cv = $('#snow');
  if (!cv || mqReduce.matches) return;
  const ctx = cv.getContext('2d');
  if (!ctx) return;
  const lite = matchMedia('(max-width: 700px)').matches || (navigator.hardwareConcurrency || 4) <= 4;
  const N = lite ? 22 : 46, ALPHA = 0.55;
  let w = 0, h = 0, flakes = [], raf = 0, running = false, inView = false, color = '#fff';
  const resize = () => {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    w = cv.clientWidth; h = cv.clientHeight;
    if (!w || !h) return;
    cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  const mk = y => ({ x: Math.random() * w, y: y == null ? Math.random() * h : y, r: 0.8 + Math.random() * 1.8, vy: 0.25 + Math.random() * 0.5, vx: -0.15 + Math.random() * 0.3, a: (0.15 + Math.random() * 0.4) * ALPHA, p: Math.random() * 6.28, ps: 0.006 + Math.random() * 0.012 });
  const loop = () => {
    raf = 0;
    if (!running) return;
    ctx.clearRect(0, 0, w, h);
    ctx.fillStyle = color;
    for (const f of flakes) {
      f.p += f.ps; f.y += f.vy; f.x += f.vx + Math.sin(f.p) * 0.3;
      if (f.y > h + 5) Object.assign(f, mk(-5));
      if (f.x < -5) f.x = w + 5; else if (f.x > w + 5) f.x = -5;
      ctx.globalAlpha = f.a;
      ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.2832); ctx.fill();
    }
    ctx.globalAlpha = 1;
    raf = requestAnimationFrame(loop);
  };
  const start = () => {
    if (running) return;
    resize();
    if (!w || !h) return;
    running = true; color = getComputedStyle(cv).color;
    if (!flakes.length) flakes = Array.from({ length: N }, () => mk());
    raf = requestAnimationFrame(loop);
  };
  const stop = () => { running = false; if (raf) cancelAnimationFrame(raf); raf = 0; };
  new IntersectionObserver(([e]) => { inView = e.isIntersecting; if (inView && !doc.hidden) start(); else stop(); }).observe(cv);
  window.addEventListener('resize', () => { if (running) resize(); });
  doc.addEventListener('visibilitychange', () => { if (doc.hidden) stop(); else if (inView) start(); });
}

/* ---------- contact form ---------- */
function initContact() {
  const form = $('#contactForm'), status = $('#cfStatus'), btn = $('#cfSubmit');
  if (CONFIG.supportEmail) {
    const p = $('#supportEmail');
    p.hidden = false;
    p.innerHTML = `Prefer email? Write to <a href="mailto:${esc(CONFIG.supportEmail)}">${esc(CONFIG.supportEmail)}</a>.`;
  }
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const rules = {
    name: v => v.trim().length >= 2 || 'Enter your name.',
    email: v => emailRe.test(v.trim()) || (v.trim() ? 'Enter a valid email address, like name@example.com.' : 'Enter your email address.'),
    phone: v => !v.trim() || (/^[+()\-.\s\d]{6,20}$/.test(v.trim()) && v.replace(/\D/g, '').length >= 6) || 'Enter a valid phone number, or leave this empty.',
    comment: v => v.trim().length >= 10 || (v.trim() ? 'Add a little more detail (at least 10 characters).' : 'Enter your message.'),
  };
  const fieldOf = n => $(`[data-field="${n}"]`, form);
  const check = n => {
    const f = fieldOf(n), input = $('.input', f), res = rules[n](input.value), ok = res === true;
    f.classList.toggle('is-invalid', !ok);
    input.setAttribute('aria-invalid', String(!ok));
    $('.field__err', f).textContent = ok ? '' : res;
    return ok;
  };
  Object.keys(rules).forEach(n => {
    const input = $('.input', fieldOf(n));
    input.addEventListener('blur', () => { if (input.value) check(n); });
    input.addEventListener('input', () => { if (fieldOf(n).classList.contains('is-invalid')) check(n); });
  });
  const done = () => {
    form.reset();
    $$('.field', form).forEach(f => f.classList.remove('is-invalid'));
    status.innerHTML = alertBox('ok', 'Thanks! Your message has been received.', 'We’ll reply to the email address you entered.');
    const a = $('.alert', status); if (a) a.focus();
  };
  if (contactPosted) done();   // Shopify sent the message and returned here
  // Shopify store: #contactForm is Shopify's own contact form ({% form 'contact' %} → POST /contact). The browser submits it
  // itself, so Shopify's CAPTCHA, which Shopify attaches to this form, adds its token first; nothing is sent from script.
  const shopifyForm = IS_SHOPIFY && !CONFIG.contact.endpoint && /\/contact(?:[#?]|$)/.test(form.getAttribute('action') || '');
  let sendTimer = 0;
  const idle = () => { clearTimeout(sendTimer); btn.classList.remove('is-loading'); btn.disabled = false; };
  window.addEventListener('pageshow', idle);   // back here with the browser's Back button
  form.addEventListener('submit', async e => {
    status.innerHTML = '';
    const bad = Object.keys(rules).filter(n => !check(n));
    if (bad.length) {
      e.preventDefault(); e.stopImmediatePropagation();   // nothing is sent while a field is wrong (Shopify's CAPTCHA waits too)
      $('.input', fieldOf(bad[0])).focus(); return;
    }
    if (shopifyForm) {
      btn.classList.add('is-loading'); btn.disabled = true;
      clearTimeout(sendTimer); sendTimer = setTimeout(idle, 20000);   // still on this page after 20 s: SEND works again
      // Shopify loads its CAPTCHA when the form is first used and holds the form back until it is ready: send once it is
      if (doc.getElementById('captcha-bootstrap') && !form.hasAttribute('data-hcaptcha-bound')) {
        form.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));   // Shopify's own trigger for loading it
        for (let i = 0; i < 100 && !form.hasAttribute('data-hcaptcha-bound'); i++) await sleep(100);
        if (form.hasAttribute('data-hcaptcha-bound')) { if (form.requestSubmit) form.requestSubmit(); else { btn.disabled = false; btn.click(); } }
      }
      return;
    }
    e.preventDefault();
    const data = Object.fromEntries(new FormData(form));
    btn.classList.add('is-loading'); btn.disabled = true;
    const t0 = performance.now();
    try {
      if (CONFIG.contact.endpoint) {
        const r = await fetch(CONFIG.contact.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
        if (!r.ok) throw new Error('send failed');
        done();
      } else {
        const wait = 450 - (performance.now() - t0);
        if (wait > 0) await sleep(wait);
        status.innerHTML = alertBox('info', 'Your message couldn’t be sent', CONFIG.supportEmail
          ? `Our contact form is currently unavailable. Please email us at <a href="mailto:${esc(CONFIG.supportEmail)}">${esc(CONFIG.supportEmail)}</a>.`
          : 'Our contact form is currently unavailable. Please try again later.');
        const a = $('.alert', status); if (a) a.focus();
      }
    } catch (err) {
      status.innerHTML = alertBox('err', 'Your message wasn’t sent', 'Check your connection and try again. If it keeps failing, email us directly.');
    } finally { btn.classList.remove('is-loading'); btn.disabled = false; }
  });
}

/* ---------- order tracking: real data only ----------
   This page never creates tracking numbers, events, locations or dates. It renders what the
   NIVORA tracking service returns: the Shopify order, the tracking number DSers synced to it,
   and the carrier data from the tracking provider (17TRACK). Contract: see the service README. */
const SHIP_STATES = {
  placed:           { label: 'Order Placed',             step: 0,    tone: 'neutral', icon: 'check' },
  processing:       { label: 'Processing',               step: 1,    tone: 'neutral', icon: 'box' },
  awaiting_scan:    { label: 'Waiting for Carrier Scan', step: 2,    tone: 'wait',    icon: 'truck' },
  shipped:          { label: 'Shipped',                  step: 2,    tone: 'info',    icon: 'truck' },
  in_transit:       { label: 'In Transit',               step: 3,    tone: 'info',    icon: 'truck' },
  arrived:          { label: 'Arrived at Destination',   step: 3,    tone: 'info',    icon: 'pin' },
  customs:          { label: 'Customs Clearance',        step: 3,    tone: 'info',    icon: 'doc' },
  out_for_delivery: { label: 'Out for Delivery',         step: 4,    tone: 'info',    icon: 'route' },
  pickup:           { label: 'Ready for Pickup',         step: 4,    tone: 'info',    icon: 'pin' },
  delivered:        { label: 'Delivered',                step: 5,    tone: 'ok',      icon: 'home' },
  exception:        { label: 'Delivery Exception',       step: null, tone: 'err',     icon: 'alert' },
  cancelled:        { label: 'Order Cancelled',          step: null, tone: 'err',     icon: 'alert' },
};
const PROGRESS = ['Ordered', 'Processing', 'Shipped', 'In Transit', 'Out for Delivery', 'Delivered'];
const stateOf = k => SHIP_STATES[k] || SHIP_STATES.processing;
const statusPill = k => { const st = stateOf(k); return `<span class="ostatus is-${st.tone}">${ICON[st.icon] || ''}${esc(st.label)}</span>`; };
const tWhen = (v, ex, time = true) => (v ? fmtDate(v, time) : ex ? 'Example date' : '');

const TrackAPI = {
  base: () => String(CONFIG.tracking.apiBase || '').replace(/\/+$/, ''),
  async req(path, init = {}) {
    const r = await fetch(this.base() + path, Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, init));
    let body = null;
    try { body = await r.json(); } catch (e) { /* no JSON body */ }
    if (!r.ok) { const err = new Error((body && body.error) || `http_${r.status}`); err.status = r.status; err.code = body && body.error; throw err; }
    return body;
  },
  lookup(order, email) { return this.req('/track', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ order, email }) }); },
  orders() { return this.req('/orders'); },
  order(name) { return this.req(`/orders/${encodeURIComponent(String(name).replace(/^#/, ''))}`); },
};
const TRACK_ERRORS = {
  order_not_found: ['info', 'We couldn’t find that order', 'We couldn’t find an order with those details. Please check your order number and email address.'],
  tracking_not_active: ['info', 'Tracking isn’t active yet', 'Your tracking number has not been activated yet. Please check again after your order ships.'],
  carrier_unavailable: ['info', 'Waiting for the carrier', 'We’re currently waiting for an update from the carrier.'],
  rate_limited: ['err', 'Too many attempts', 'Please wait a minute and try again.'],
  invalid_input: ['err', 'Check your details', 'Please enter a valid order number and email address.'],
};
function trackErrorHTML(err) {
  const s = err && err.status;
  const code = (err && err.code) || (s === 404 ? 'order_not_found' : s === 429 ? 'rate_limited' : s === 502 || s === 503 ? 'carrier_unavailable' : '');
  const [type, t, d] = TRACK_ERRORS[code] || ['err', 'Tracking couldn’t load', 'Check your connection and try again. If it keeps failing, contact us.'];
  return alertBox(type, t, d);
}
function furthestStep(order, s) {
  if (!s) return order && order.processedAt ? 1 : 0;
  const m = s.milestones || {};
  return m.delivered ? 5 : m.out_for_delivery || m.pickup ? 4 : m.in_transit ? 3 : 2;
}
function shipmentHTML(order, s, overall, idx, total, ex) {
  const key = s ? s.state : overall;
  const st = stateOf(key);
  const cur = st.step != null ? st.step : furthestStep(order, s);
  const ev = s && s.latestEvent;
  let msg;
  if (!s) msg = key === 'cancelled' ? 'This order was cancelled.' : 'Tracking information will be available once your order has shipped.';
  else if (s.providerError) msg = 'We’re currently waiting for an update from the carrier.';
  else if (key === 'awaiting_scan') msg = 'Tracking number created. Waiting for the first carrier scan.';
  else if (key === 'delivered' && s.milestones && s.milestones.delivered) msg = `Delivered on ${fmtDate(s.milestones.delivered, true)}`;
  else if (ev && ev.message) msg = ev.message;
  else msg = st.label;
  const sub = s && ev && !s.providerError && key !== 'awaiting_scan' ? [tWhen(ev.time, ex), ev.location].filter(Boolean).join(' · ') : '';
  const m = (s && s.milestones) || {};
  const dates = [order.createdAt, order.processedAt, s && s.shippedAt, m.in_transit, m.out_for_delivery || m.pickup, m.delivered];
  const e = s && s.estimatedDelivery;
  const est = e && (e.from || e.to) ? [...new Set([e.from, e.to].filter(Boolean).map(v => fmtDate(v)))].join(' – ') : '';
  const events = s && Array.isArray(s.events) ? s.events : [];
  const steps = PROGRESS.map((label, k) => {
    const cls = k < cur ? 'is-done' : k === cur ? `is-current${st.tone === 'err' ? ' is-err' : ''}` : '';
    const d = k <= cur ? tWhen(dates[k], ex, false) || '—' : '—';
    const note = k === cur && (st.tone === 'err' || (st.step === cur && SHIP_STATES[key] && key !== 'in_transit' && cur === 3)) ? `${st.label} · ` : '';
    return `<li class="${cls}"${k === cur ? ' aria-current="step"' : ''}><span class="sv__dot">${k < cur ? ICON.check : k === cur ? ICON[st.icon] || ICON.truck : ''}</span><div><p class="sv__t">${label}</p><p class="sv__d">${esc(note + d)}</p></div></li>`;
  }).join('');
  return `<article class="trk-ship">
    ${total > 1 ? `<p class="trk-ship__n">SHIPMENT ${idx + 1} OF ${total}</p>` : ''}
    <section class="trk-hero is-${st.tone}" aria-label="Current shipping status">
      <div class="trk-hero__top"><span class="trk-hero__icon" aria-hidden="true">${ICON[st.icon] || ICON.truck}</span>
        <div><p class="trk-hero__k">STATUS</p><p class="trk-hero__status">${esc(st.label)}</p></div></div>
      <p class="trk-hero__msg">${esc(msg)}</p>
      ${sub ? `<p class="trk-hero__sub">${esc(sub)}</p>` : ''}
      <dl class="trk-hero__meta">
        <div><dt>Order</dt><dd>${esc(order.name || '—')}</dd></div>
        ${s ? `<div class="is-wide"><dt>Tracking number</dt><dd><span class="mono">${esc(s.trackingNumber || '—')}</span>${s.trackingNumber ? `<button class="copy" type="button" data-copy="${esc(s.trackingNumber)}" aria-label="Copy tracking number">${ICON.copy}</button>` : ''}</dd></div>
        <div><dt>Carrier</dt><dd>${esc(s.carrier || 'Not available yet')}</dd></div>` : ''}
        ${est ? `<div><dt>Estimated delivery</dt><dd>${esc(est)}</dd></div>` : ''}
        ${s && (s.lastUpdate || ex) ? `<div><dt>Last update</dt><dd>${esc(tWhen(s.lastUpdate, ex))}</dd></div>` : ''}
      </dl>
      ${s && s.trackingUrl ? `<a class="btn btn--primary trk-hero__btn" href="${esc(s.trackingUrl)}" target="_blank" rel="noopener">TRACK ON CARRIER WEBSITE</a>` : ''}
    </section>
    <div class="trk-grid">
      <section class="trk-card"><h3 class="trk-card__t">SHIPMENT PROGRESS</h3><ol class="sv">${steps}</ol></section>
      <section class="trk-card"><h3 class="trk-card__t">TRACKING HISTORY</h3>
        ${events.length ? `<ol class="hist">${events.map((v, k) => `<li${k === 0 ? ' class="is-latest"' : ''}><p class="hist__time">${esc(tWhen(v.time, ex) || '—')}</p><p class="hist__msg">${esc(v.message || '')}</p>${v.location ? `<p class="hist__loc">${esc(v.location)}</p>` : ''}</li>`).join('')}</ol>`
          : `<p class="trk-empty">${s ? 'No carrier scans yet. Events appear here as soon as the carrier scans your parcel.' : 'The tracking history appears here once your order has shipped.'}</p>`}
      </section>
    </div>
  </article>`;
}
function trackResultHTML(d, opts = {}) {
  const ex = !!(opts.example || (d && d.example));
  const order = (d && d.order) || {};
  const ships = d && Array.isArray(d.shipments) && d.shipments.length ? d.shipments : [null];
  return `<div class="trk">${opts.flag ? `<p class="tr__flag">${ICON.alert}Example layout for the preview — not real tracking data.</p>` : ''}${ships.map((s, i) => shipmentHTML(order, s, (d && d.state) || 'processing', i, ships.length, ex)).join('')}</div>`;
}
/* preview-only example (never shown when showPlaceholders is false) */
const exampleTracking = () => ({
  example: true, state: 'in_transit',
  order: { name: '#1001', createdAt: null, processedAt: null, financialStatus: 'Paid', quantity: 1, subtotal: PRICE, discount: 0, shipping: 0, total: totalFor(1), currency: 'EUR',
    items: [{ title: CONFIG.product.cartTitle, quantity: 1 }], shippingAddress: ['Example Customer', 'Example Street 1', '00000 Example City'] },
  shipments: [{ trackingNumber: 'EX0000000000', carrier: 'Example Carrier', trackingUrl: '', state: 'in_transit', shippedAt: null, lastUpdate: null, estimatedDelivery: null, milestones: {},
    latestEvent: { time: null, message: 'Example: departed sorting facility', location: 'Example location' },
    events: [
      { time: null, message: 'Example: departed sorting facility', location: 'Example location' },
      { time: null, message: 'Example: arrived at sorting facility', location: 'Example location' },
      { time: null, message: 'Example: picked up by carrier', location: 'Example location' },
      { time: null, message: 'Example: shipment information received', location: '' },
    ] }],
});
const exampleOrderSummary = () => ({ name: '#1001', createdAt: null, quantity: 1, total: totalFor(1), product: CONFIG.product.cartTitle, state: 'in_transit', trackingNumber: 'EX0000000000', carrier: 'Example Carrier', example: true });

let pendingTrack = null;
function initTrack() {
  const form = $('#trackForm'), out = $('#trackOut'), btn = $('#tSubmit');
  const fOrder = $('#tOrder'), fEmail = $('#tEmail');
  const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const setErr = (input, msg) => {
    const f = input.closest('.field');
    f.classList.toggle('is-invalid', !!msg);
    input.setAttribute('aria-invalid', String(!!msg));
    $('.field__err', f).textContent = msg;
  };
  const validate = () => {
    const o = fOrder.value.trim(), e = fEmail.value.trim();
    setErr(fOrder, !o ? 'Enter your order number.' : /^#?[A-Za-z0-9-]{3,24}$/.test(o) ? '' : 'Enter the order number from your confirmation email, like #1001.');
    setErr(fEmail, !e ? 'Enter the email address you used at checkout.' : emailRe.test(e) ? '' : 'Enter a valid email address, like name@example.com.');
    return $$('.field.is-invalid', form);
  };
  [fOrder, fEmail].forEach(i => i.addEventListener('input', () => { if (i.closest('.field').classList.contains('is-invalid')) validate(); }));
  const show = html => {
    out.innerHTML = html;
    const el = $('.trk, .alert', out);
    if (el) { el.tabIndex = -1; el.focus({ preventScroll: true }); el.scrollIntoView({ behavior: smooth(), block: 'start' }); }
  };
  form.addEventListener('submit', async e => {
    e.preventDefault();
    out.innerHTML = '';
    const bad = validate();
    if (bad.length) { $('.input', bad[0]).focus(); return; }
    const order = `#${fOrder.value.trim().replace(/^#/, '')}`, email = fEmail.value.trim();
    btn.classList.add('is-loading'); btn.disabled = true;
    const t0 = performance.now();
    const minWait = async () => { const w = 400 - (performance.now() - t0); if (w > 0) await sleep(w); };
    try {
      if (!TrackAPI.base()) {
        await minWait();
        show(alertBox('info', 'Order tracking is currently unavailable', 'Please use the tracking link in your shipping confirmation email, or contact us and we’ll check your order for you.',
          '<a class="btn" href="#/contact">CONTACT US</a>'));
        return;
      }
      const d = await TrackAPI.lookup(order, email);
      await minWait();
      show(trackResultHTML(d));
    } catch (err) {
      await minWait();
      show(trackErrorHTML(err));
    } finally { btn.classList.remove('is-loading'); btn.disabled = false; }
  });
  // a known tracking number can always be opened on the public carrier page (real data)
  const toggle = $('#tAltToggle'), alt = $('#tAlt'), num = $('#tNumber');
  toggle.addEventListener('click', () => { const open = alt.hidden; alt.hidden = !open; toggle.setAttribute('aria-expanded', String(open)); if (open) num.focus(); });
  alt.addEventListener('submit', e => {
    e.preventDefault();
    const v = num.value.replace(/\s/g, '').toUpperCase();
    const ok = /^[A-Z0-9]{8,34}$/.test(v);
    setErr(num, !v ? 'Enter your tracking number.' : ok ? '' : 'Enter the tracking number from your shipping email (8–34 letters and numbers).');
    if (!ok) { num.focus(); return; }
    const url = CONFIG.tracking.trackingUrl ? CONFIG.tracking.trackingUrl.replace('{number}', encodeURIComponent(v)) : '';
    show(url ? alertBox('ok', `Tracking number ${esc(v)}`, 'Live tracking from the carrier opens in a new tab.', `<a class="btn" href="${esc(url)}" target="_blank" rel="noopener">OPEN CARRIER TRACKING</a>`)
      : alertBox('info', 'Carrier tracking is currently unavailable', 'Please use the tracking link in your shipping confirmation email.'));
  });
  const tt = $('#ttForm');
  if (tt) tt.addEventListener('submit', e => { e.preventDefault(); pendingTrack = { order: $('#ttOrder').value.trim(), email: $('#ttEmail').value.trim() }; nav('#/track'); });
  doc.addEventListener('click', e => {
    const c = e.target.closest('[data-copy]');
    if (!c) return;
    const done = () => toast('Tracking number copied.');
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(c.dataset.copy).then(done, () => toast(c.dataset.copy));
    else toast(c.dataset.copy);
  });
}
function onTrackShown() {
  renderTrackMine();
  if (!pendingTrack) return;
  const p = pendingTrack; pendingTrack = null;
  $('#tOrder').value = p.order; $('#tEmail').value = p.email;
  if (p.order || p.email) $('#trackForm').requestSubmit();
}
async function renderTrackMine() {
  const box = $('#trackMine');
  if (!currentCustomer()) { box.innerHTML = ''; return; }
  box.innerHTML = `<div class="mine"><p class="block-title">YOUR ORDERS</p><p class="note">You’re logged in, so your orders are listed here. No email needed.</p><div class="mine__list" id="mineList"><p class="note">Loading your orders…</p></div></div>`;
  try {
    const orders = await loadOrders();
    const list = $('#mineList');
    if (!list) return;
    list.innerHTML = orders.length ? orders.map(o => `<a class="mine__item" href="#/account/orders/${encodeURIComponent(String(o.name).replace(/^#/, ''))}"><span><b>Order ${esc(o.name)}${o.example ? ' <span class="ph-pill">Example</span>' : ''}</b><small>${esc(stateOf(o.state).label)}</small></span>${ICON.chevRight}</a>`).join('') : '<p class="note">No orders yet.</p>';
  } catch (err) {
    const list = $('#mineList');
    if (list) list.innerHTML = `<p class="note">${err && err.status === 401 ? 'Please log in again to see your orders.' : 'Your orders couldn’t load right now.'}</p>`;
  }
}

/* ---------- customer accounts (optional) ----------
   No fake login and no stored passwords. In the preview the forms validate and then explain that
   accounts aren't connected. On Shopify they use Shopify customer accounts. When a customer is
   logged in, the theme exposes the profile as window.NIVORA_CUSTOMER = { first_name, last_name, email }
   and orders come from the tracking service (GET {apiBase}/orders via the Shopify app proxy). */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const Account = { example: false };
const authMode = () => CONFIG.auth.mode || (IS_SHOPIFY ? 'shopify' : '');
function currentCustomer() {
  if (Account.example) return { firstName: 'Example', lastName: 'Customer', email: 'customer@example.com', example: true };
  const c = window.NIVORA_CUSTOMER;
  return c && c.email ? { firstName: c.first_name || c.firstName || '', lastName: c.last_name || c.lastName || '', email: c.email } : null;
}
async function loadOrders() {
  if (Account.example) return [exampleOrderSummary()];
  if (!TrackAPI.base()) { const err = new Error('not_connected'); err.code = 'not_connected'; throw err; }
  const d = await TrackAPI.orders();
  return (d && d.orders) || [];
}
async function loadOrder(name) {
  if (Account.example) return exampleTracking();
  if (!TrackAPI.base()) { const err = new Error('not_connected'); err.code = 'not_connected'; throw err; }
  return TrackAPI.order(name);
}

const Auth = {
  post(action, fields) {
    const f = doc.createElement('form');
    f.method = 'post'; f.action = action; f.hidden = true;
    Object.entries(Object.assign({ utf8: '✓' }, fields)).forEach(([k, v]) => { const i = doc.createElement('input'); i.type = 'hidden'; i.name = k; i.value = v; f.appendChild(i); });
    doc.body.appendChild(f); f.submit();
    return 'redirect';
  },
  async json(url, body) {
    if (!url) throw { notConnected: true };
    const r = await fetch(url, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    if (!r.ok) {
      let m = '';
      try { m = (await r.json()).message || ''; } catch (e) { /* no body */ }
      throw new Error(m || (r.status === 401 ? 'Email or password is incorrect.' : 'Something went wrong. Please try again.'));
    }
    return 'ok';
  },
  login(d) {
    const m = authMode();
    if (m === 'shopify') return this.post('/account/login', { form_type: 'customer_login', 'customer[email]': d.email, 'customer[password]': d.password });
    if (m === 'shopify-hosted') { location.href = '/account/login'; return 'redirect'; }
    if (m === 'endpoint') return this.json(CONFIG.auth.endpoints.login, d);
    throw { notConnected: true };
  },
  register(d) {
    const m = authMode();
    if (m === 'shopify') return this.post('/account', { form_type: 'create_customer', 'customer[first_name]': d.firstName, 'customer[last_name]': d.lastName, 'customer[email]': d.email, 'customer[password]': d.password });
    if (m === 'shopify-hosted') { location.href = '/account/login'; return 'redirect'; }
    if (m === 'endpoint') return this.json(CONFIG.auth.endpoints.register, d);
    throw { notConnected: true };
  },
  recover(email) {
    const m = authMode();
    if (m === 'shopify') return this.post('/account/recover', { form_type: 'recover_customer_password', email });
    if (m === 'shopify-hosted') { location.href = '/account/login'; return 'redirect'; }
    if (m === 'endpoint') return this.json(CONFIG.auth.endpoints.recover, { email });
    throw { notConnected: true };
  },
  logout() {
    const m = authMode();
    if (m === 'shopify' || m === 'shopify-hosted') { location.href = '/account/logout'; return; }
    if (m === 'endpoint' && CONFIG.auth.endpoints.logout) { fetch(CONFIG.auth.endpoints.logout, { method: 'POST', credentials: 'include' }).finally(() => location.reload()); }
  },
};

const dval = (v, fmt) => (v ? esc(fmt ? fmt(v) : v) : '<span class="muted">Not available yet</span>');
const flagHTML = () => '';
const back = (href, label) => `<a class="back" href="${href}">${ICON.chevRight}${label}</a>`;
const txtField = (id, label, type, auto) =>
  `<div class="field" data-field="${id}"><label for="${id}">${label}</label><input class="input" id="${id}" name="${id}" type="${type}" autocomplete="${auto}"${type === 'email' ? ' inputmode="email"' : ''} aria-describedby="${id}Err"><p class="field__err" id="${id}Err"></p></div>`;
const pwField = (id, label, auto, hint = '') =>
  `<div class="field" data-field="${id}"><label for="${id}">${label}</label><div class="pw"><input class="input" id="${id}" name="${id}" type="password" autocomplete="${auto}" aria-describedby="${id}Err${hint ? ` ${id}Hint` : ''}"><button class="pw__toggle" type="button" aria-label="Show password" aria-pressed="false" data-pw="${id}">${ICON.eye}</button></div>${hint ? `<p class="field__hint" id="${id}Hint">${hint}</p>` : ''}<p class="field__err" id="${id}Err"></p></div>`;
const submitBtn = label => `<button class="btn btn--xl btn--primary" type="submit"><span class="btn__label">${label}</span><span class="btn__spin" aria-hidden="true"></span></button><div class="form-status" role="status" aria-live="polite"></div>`;

function authHTML(login) {
  return `<h1 class="page__title" id="acctTitle">MY ACCOUNT</h1>
  <p class="page__lead">${login ? 'Log in to see your orders and their real shipping status.' : 'Create an account to keep all your orders in one place.'} An account is optional: you can always order and track as a guest.</p>
  <div class="auth-card">
    <nav class="seg" data-active="${login ? 0 : 1}" aria-label="Login or register"><span class="seg__ink" aria-hidden="true"></span><a href="#/account/login"${login ? ' aria-current="page"' : ''}>LOGIN</a><a href="#/account/register"${login ? '' : ' aria-current="page"'}>REGISTER</a></nav>
    ${login ? `<form class="form" id="loginForm" novalidate style="margin-top:0">
      ${txtField('lEmail', 'Email', 'email', 'email')}
      ${pwField('lPass', 'Password', 'current-password')}
      <div class="auth-row"><a class="linkish" href="#/account/recover">Forgot password?</a></div>
      ${submitBtn('LOGIN')}
    </form>` : `<form class="form" id="registerForm" novalidate style="margin-top:0">
      <div class="form__row form__row--2">${txtField('rFirst', 'First name', 'text', 'given-name')}${txtField('rLast', 'Last name', 'text', 'family-name')}</div>
      ${txtField('rEmail', 'Email', 'email', 'email')}
      ${pwField('rPass', 'Password', 'new-password', 'At least 8 characters.')}
      ${pwField('rPass2', 'Confirm password', 'new-password')}
      ${submitBtn('CREATE ACCOUNT')}
    </form>`}
  </div>
  <div class="auth-foot"><span>No account needed to order. <a href="#/track">Track an order as a guest</a></span></div>`;
}
function recoverHTML() {
  return `${back('#/account/login', 'Back to login')}
  <h1 class="page__title" id="acctTitle">RESET PASSWORD</h1>
  <p class="page__lead">Enter your email address and we’ll send you a link to set a new password.</p>
  <div class="auth-card"><form class="form" id="recoverForm" novalidate style="margin-top:0">${txtField('pEmail', 'Email', 'email', 'email')}${submitBtn('SEND RESET LINK')}</form></div>`;
}
function orderCard(o) {
  const href = `#/account/orders/${encodeURIComponent(String(o.name).replace(/^#/, ''))}`;
  return `<article class="ocard">
    <div class="ocard__top"><div><p class="ocard__no">ORDER ${esc(o.name)}</p><p class="rcard__date">${o.example ? 'Example date' : o.createdAt ? fmtDate(o.createdAt) : ''}</p></div>${statusPill(o.state)}</div>
    <div class="prodline"><img src="${esc(imgSrc(CONFIG.product.image))}" alt="" width="56" height="56"><div><b>${esc(o.product || CONFIG.product.cartTitle)}</b><span>Qty: ${o.quantity || 1}</span></div><strong>${o.total != null ? money(o.total) : ''}</strong></div>
    ${o.trackingNumber ? `<dl class="kv kv--2"><div><dt>Tracking number</dt><dd class="mono">${esc(o.trackingNumber)}</dd></div><div><dt>Carrier</dt><dd>${dval(o.carrier)}</dd></div></dl>` : ''}
    <div class="ocard__actions"><a class="btn btn--primary" href="${href}">VIEW ORDER</a></div>
  </article>`;
}
function dashHTML(c) {
  return `<p class="acct-hello">Welcome, ${esc(c.firstName || 'back')}</p>
  <h1 class="page__title" id="acctTitle">MY ACCOUNT</h1>${flagHTML()}
  <div class="acct-grid">
    <section class="acct-card"><h2 class="acct-card__t">ACCOUNT INFORMATION</h2>
      <dl class="kv"><div><dt>Name</dt><dd>${dval([c.firstName, c.lastName].filter(Boolean).join(' '))}</dd></div><div><dt>Email</dt><dd>${dval(c.email)}</dd></div></dl>
      <a class="linkish" href="#/account/settings">Account settings</a></section>
    <nav class="tiles" aria-label="Account">
      <a class="tile" href="#/account/orders">${ICON.box}<b>My Orders</b><span>Orders and tracking</span></a>
      <a class="tile" href="#/track">${ICON.route}<b>Track Order</b><span>Order number + email</span></a>
      <a class="tile" href="#/account/settings">${ICON.gear}<b>Account Settings</b><span>Profile and password</span></a>
      <button class="tile" type="button" data-logout>${ICON.logout}<b>Logout</b><span>Sign out</span></button>
    </nav>
  </div>
  <p class="block-title" style="margin-top:26px">LATEST ORDER</p><div id="dashLatest"><p class="skel">Loading your orders…</p></div>`;
}
function ordersHTML() {
  return `${back('#/account', 'My Account')}<h1 class="page__title" id="acctTitle">MY ORDERS</h1>${flagHTML()}
  <div id="ordersList" style="margin-top:20px"><p class="skel">Loading your orders…</p></div>`;
}
function orderShellHTML(id) {
  return `${back('#/account/orders', 'My Orders')}<h1 class="page__title" id="acctTitle">ORDER #${esc(String(id).toUpperCase())}</h1>${flagHTML()}
  <div id="orderBody" style="margin-top:20px"><p class="skel">Loading order details…</p></div>`;
}
function orderBodyHTML(d) {
  const o = d.order || {}, ex = !!d.example;
  const free = CONFIG.freeShipping && !o.shipping;
  const items = (o.items && o.items.length ? o.items : [{ title: CONFIG.product.cartTitle, quantity: o.quantity || 1 }]);
  return `<div class="acct-grid">
    <section class="acct-card"><h2 class="acct-card__t">ORDER DETAILS</h2>
      ${items.map(it => `<div class="prodline" style="margin-top:0"><img src="${esc(imgSrc(CONFIG.product.image))}" alt="" width="56" height="56"><div><b>${esc(it.title)}</b><span>Quantity: ${it.quantity}</span></div></div>`).join('')}
      <dl class="sum">
        <div><dt>Price</dt><dd>${o.subtotal != null ? money(o.subtotal) : '—'}</dd></div>
        ${o.discount ? `<div class="is-save"><dt>Multi-buy discount</dt><dd>${money(-o.discount)}</dd></div>` : ''}
        <div class="${free ? 'is-free' : ''}"><dt>Shipping</dt><dd>${free ? 'FREE' : o.shipping != null ? money(o.shipping) : '—'}</dd></div>
        <div><dt>Payment status</dt><dd>${dval(o.financialStatus)}</dd></div>
        <div class="is-total"><dt>Total</dt><dd>${o.total != null ? money(o.total) : '—'}</dd></div>
      </dl></section>
    <section class="acct-card"><h2 class="acct-card__t">SHIPPING</h2>
      <dl class="kv">
        <div><dt>Shipping address</dt><dd>${o.shippingAddress && o.shippingAddress.length ? o.shippingAddress.map(esc).join('<br>') : '<span class="muted">Not available</span>'}</dd></div>
        <div><dt>Order date</dt><dd>${ex ? 'Example date' : dval(o.createdAt, v => fmtDate(v))}</dd></div>
      </dl></section>
  </div>
  <div class="od-section">${trackResultHTML(d, { example: ex })}</div>`;
}
function settingsHTML(c) {
  return `${back('#/account', 'My Account')}<h1 class="page__title" id="acctTitle">ACCOUNT SETTINGS</h1>${flagHTML()}
  <div class="acct-grid">
    <section class="acct-card"><h2 class="acct-card__t">PROFILE</h2>
      <dl class="kv"><div><dt>First name</dt><dd>${dval(c.firstName)}</dd></div><div><dt>Last name</dt><dd>${dval(c.lastName)}</dd></div><div><dt>Email</dt><dd>${dval(c.email)}</dd></div></dl>
      <p class="note" style="margin-top:12px">Profile details are managed securely through your Shopify customer account.</p>
      <div class="ocard__actions"><button class="btn btn--ghost" type="button" data-acct-action="profile">EDIT PROFILE</button></div></section>
    <section class="acct-card"><h2 class="acct-card__t">PASSWORD</h2>
      <p class="note">For your security, passwords are changed with a reset link sent to your email address.</p>
      <div class="ocard__actions"><button class="btn btn--ghost" type="button" data-acct-action="reset">SEND RESET LINK</button></div>
      <h2 class="acct-card__t" style="margin-top:20px">SIGN OUT</h2>
      <div class="ocard__actions" style="margin-top:0"><button class="btn btn--ghost" type="button" data-logout>LOGOUT</button></div></section>
  </div>`;
}
let acctToken = 0;
const loadErrorHTML = err => (err && err.code === 'not_connected'
  ? alertBox('info', 'Your orders can’t be loaded right now', 'Please try again later.')
  : err && err.status === 401 ? alertBox('info', 'Please log in again', 'Your session has expired. Log in to see your orders.', '<a class="btn" href="#/account/login">LOGIN</a>')
  : err && err.status === 404 ? alertBox('info', 'Order not found', 'We couldn’t find this order in your account.', '<a class="btn btn--ghost" href="#/account/orders">MY ORDERS</a>')
  : trackErrorHTML(err));
function renderAccount(r) {
  const c = currentCustomer();
  const token = ++acctToken;
  let sub = r.sub;
  if (c && (!sub || sub === 'login' || sub === 'register')) sub = 'dashboard';
  if (!c && (!sub || sub === 'orders' || sub === 'settings')) sub = 'login';
  if (sub === 'orders' && r.id) sub = 'order';
  const root = $('#acctRoot');
  const views = { login: () => authHTML(true), register: () => authHTML(false), recover: recoverHTML, dashboard: () => dashHTML(c), orders: ordersHTML, order: () => orderShellHTML(r.id), settings: () => settingsHTML(c) };
  root.innerHTML = (views[sub] || views.login)();
  const alive = () => token === acctToken;
  if (sub === 'dashboard' || sub === 'orders') {
    loadOrders().then(list => {
      if (!alive()) return;
      const box = $(sub === 'dashboard' ? '#dashLatest' : '#ordersList');
      if (!box) return;
      const shown = sub === 'dashboard' ? list.slice(0, 1) : list;
      box.innerHTML = shown.length ? `<div class="orders" style="margin-top:0">${shown.map(orderCard).join('')}</div>`
        : `<div class="empty">${ICON.box}<p>You haven’t placed any orders yet.</p><a class="btn btn--primary" href="#/shop">SHOP NOW</a></div>`;
    }).catch(err => { if (alive()) { const box = $(sub === 'dashboard' ? '#dashLatest' : '#ordersList'); if (box) box.innerHTML = loadErrorHTML(err); } });
  }
  if (sub === 'order') {
    loadOrder(r.id).then(d => { if (alive() && $('#orderBody')) $('#orderBody').innerHTML = orderBodyHTML(d); })
      .catch(err => { if (alive() && $('#orderBody')) $('#orderBody').innerHTML = loadErrorHTML(err); });
  }
}
function initAccount() {
  const root = $('#acctRoot');
  const setErr = (input, msg) => {
    const f = input.closest('.field');
    f.classList.toggle('is-invalid', !!msg);
    if (msg) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    $('.field__err', f).textContent = msg;
  };
  const check = pairs => { pairs.forEach(([i, m]) => setErr(i, m)); const bad = pairs.find(([, m]) => m); if (bad) bad[0].focus(); return !bad; };
  const emailMsg = v => (!v ? 'Enter your email address.' : EMAIL_RE.test(v) ? '' : 'Enter a valid email address, like name@example.com.');
  const run = async (form, fn, unavailableTitle) => {
    const btn = $('button[type="submit"]', form), status = $('.form-status', form);
    status.innerHTML = '';
    btn.classList.add('is-loading'); btn.disabled = true;
    const t0 = performance.now();
    try {
      const res = await fn();
      if (res === 'redirect') return;
      if (res === 'ok') { location.reload(); return; }
    } catch (err) {
      const w = 350 - (performance.now() - t0); if (w > 0) await sleep(w);
      $$('input[type="password"]', form).forEach(i => { i.value = ''; });
      status.innerHTML = err && err.notConnected
        ? alertBox('info', unavailableTitle, 'Please try again later. You can still order and track your order as a guest.')
        : alertBox('err', esc(err && err.message ? err.message : 'Something went wrong'), 'Please try again.');
    } finally { btn.classList.remove('is-loading'); btn.disabled = false; }
  };
  root.addEventListener('submit', e => {
    const f = e.target;
    e.preventDefault();
    if (f.id === 'loginForm') {
      const em = $('#lEmail', f), pw = $('#lPass', f);
      if (!check([[em, emailMsg(em.value.trim())], [pw, pw.value ? '' : 'Enter your password.']])) return;
      run(f, () => Auth.login({ email: em.value.trim(), password: pw.value }), 'Login is currently unavailable');
    } else if (f.id === 'registerForm') {
      const fi = $('#rFirst', f), la = $('#rLast', f), em = $('#rEmail', f), pw = $('#rPass', f), pw2 = $('#rPass2', f);
      if (!check([
        [fi, fi.value.trim() ? '' : 'Enter your first name.'], [la, la.value.trim() ? '' : 'Enter your last name.'],
        [em, emailMsg(em.value.trim())], [pw, pw.value.length >= 8 ? '' : 'Use at least 8 characters.'],
        [pw2, !pw2.value ? 'Confirm your password.' : pw2.value === pw.value ? '' : 'The passwords don’t match.'],
      ])) return;
      run(f, () => Auth.register({ firstName: fi.value.trim(), lastName: la.value.trim(), email: em.value.trim(), password: pw.value }), 'Registration is currently unavailable');
    } else if (f.id === 'recoverForm') {
      const em = $('#pEmail', f);
      if (!check([[em, emailMsg(em.value.trim())]])) return;
      run(f, () => Auth.recover(em.value.trim()), 'Password reset is currently unavailable');
    }
  });
  root.addEventListener('input', e => { const f = e.target.closest('.field.is-invalid'); if (f) setErr(e.target, ''); });
  root.addEventListener('click', e => {
    const pw = e.target.closest('[data-pw]');
    if (pw) {
      const i = $(`#${pw.dataset.pw}`), show = i.type === 'password';
      i.type = show ? 'text' : 'password';
      pw.setAttribute('aria-pressed', String(show)); pw.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
      pw.innerHTML = show ? ICON.eyeOff : ICON.eye;
      return;
    }
    if (e.target.closest('[data-logout]')) { Auth.logout(); return; }
    const act = e.target.closest('[data-acct-action]');
    if (!act) return;
    const live = authMode() && !Account.example, c = currentCustomer();
    if (act.dataset.acctAction === 'profile') { if (live) location.href = '/account'; else toast('Profile editing is currently unavailable.'); }
    if (act.dataset.acctAction === 'reset') { if (live && c) { try { Auth.recover(c.email); } catch (err) { toast('Password reset isn’t available right now.'); } } else toast('Password reset is currently unavailable.'); }
  });
}

/* ---------- policies, static facts, structured data ---------- */
function renderPolicy(slug) {
  const p = POLICIES[slug];
  $('#policyTitle').textContent = p.title;
  $('#policyNote').innerHTML = `This page is a template. Replace the bracketed text with your store’s own policy before going live. On Shopify, link to <strong>/policies/${slug}</strong>, which shows the text from Settings → Policies.`;
  $('#policyBody').innerHTML = p.sections.map(([h, t]) => `<h2>${esc(h)}</h2><p>${esc(t)}</p>`).join('');
}
function renderStatic() {
  $$('[data-brand]').forEach(el => { el.textContent = CONFIG.brand; });
  $('#ftrTag').textContent = CONFIG.tagline;
  $('#year').textContent = new Date().getFullYear();
  $('#pdpTitle').innerHTML = (CONFIG.product.titleLines || [CONFIG.product.title]).map(l => `<span>${esc(l)}</span>`).join(' ');
  $('#trustline').textContent = CONFIG.trustline;
  $$('[data-pay]').forEach(ul => { ul.innerHTML = CONFIG.payments.map(p => `<li>${esc(p)}</li>`).join(''); });
  if (IS_SHOPIFY) $$('a[data-policy-link]').forEach(a => { a.href = '/policies/' + a.getAttribute('href').split('/').pop(); });
  const ld = {
    '@context': 'https://schema.org', '@type': 'Product', name: CONFIG.product.title, description: CONFIG.product.description,
    brand: { '@type': 'Brand', name: CONFIG.brand },
    offers: { '@type': 'Offer', price: (PRICE / 100).toFixed(2), priceCurrency: 'EUR', availability: 'https://schema.org/InStock' },
  };
  if (SHOP && SHOP.product) {   // Shopify: the real product URL and stock status
    const u = location.origin + (SHOP.product.url || '');
    ld.url = u; ld.offers.url = u;
    if (SHOP.product.image) ld.image = SHOP.product.image;
    ld.offers.availability = `https://schema.org/${SHOP.product.available === false ? 'OutOfStock' : 'InStock'}`;
  }
  const rs = CONFIG.reviewSummary || {};
  if (rs.average && rs.count) ld.aggregateRating = { '@type': 'AggregateRating', ratingValue: rs.average, reviewCount: rs.count };
  $('#ldProduct').textContent = JSON.stringify(ld);
}

/* ---------- boot ---------- */
function init() {
  hydrate();
  renderStatic();
  initCountdown();
  initHeader();
  initGallery();
  initFeatures();
  renderTrust();
  renderOffer();
  selectTier(state.qty, true);
  renderReviews();
  renderGuarantee();
  renderCustomerPhotos();
  renderTrustBar();
  initFeaturesRow();
  renderFaq();
  buildIndex();
  initSearch();
  initCart();
  initScrollUi();
  initReveal();
  initSnow();
  initContact();
  initTrack();
  initAccount();
  applyRoute({ first: true });
  if (SHOP) initShopifyPage();
}
// Shopify-only extras: /cart opens the cart drawer, /search opens the search, setup notes in the theme editor
function initShopifyPage() {
  if (SHOP.pageType === 'cart') openLayer($('#cart'), { focus: '[data-close]' });
  if (SHOP.pageType === 'search') {
    const q = new URLSearchParams(location.search).get('q') || '';
    $('#searchBtn').click();
    if (q) { $('#sInput').value = q; $('#sInput').dispatchEvent(new Event('input')); }
  }
  if (SHOP.designMode && SETUP.length) {
    const n = doc.createElement('div');
    n.className = 'omm-setup'; n.setAttribute('role', 'note');
    n.innerHTML = `<p class="omm-setup__t">Theme setup · only visible in the theme editor</p><ul>${SETUP.map(t => `<li>${esc(t)}</li>`).join('')}</ul>`;
    doc.body.appendChild(n);
  }
}
init();
})();
